import React, { Fragment, useState, useEffect, useRef } from "react";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import ModalComponent from "../modalComponent/ModalComponent";
import Input from "../input/Input";
import OtpInput from "react-otp-input";
import MediaQuery from "react-responsive";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdAnalytics, IoMdClose } from "react-icons/io";
import {
  getmedium,
  getstandardbyMID,
  checkuserid,
  createTeacher,
  createStudent,
  useridsuggestion,
  createParent,
  getuseridDetails,
  userlogin,
  otpverfication,
  otpgenerate,
  forgetpwd,
  addStudentBook,
  getUserListFromUsers,
  postalPincode,
  createAdmin,
  getInstitutionName,
  getcountriesbyPincode,
  getStateName,
  getcityName,
  getareaname,
  otpgenerateforRegister,
  otpresetforUser
} from "../../Services/ApiService";
import {
  FaBook,
  FaBookMedical,
  FaChevronDown,
  FaExclamationCircle,
  FaUnlock,
} from "react-icons/fa";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import Public from "../../Routes/Public";
import Private from "../../Routes/Private";
import moment from "moment";
import headerEmbelem from "../../Assests_Url/Ncert White_new.png";
import lOGOhEAD from "../../Assests_Url/lOGOhEAD.png";
import { BiLogInCircle } from "react-icons/bi";
import {
  MdArrowDropUp,
  MdOutlineLogout,
  MdOutlineSearch,
} from "react-icons/md";
import { MdOutlineMic } from "react-icons/md";
import { IoPersonCircle } from "react-icons/io5";
import { VscFeedback } from "react-icons/vsc";
import { AiOutlineCheckCircle } from "react-icons/ai";

import { CgProfile } from "react-icons/cg";
import { TbBook2 } from "react-icons/tb";
import { GoUnlock } from "react-icons/go";

const languages = [
  { code: "en", label: "English" },
  { code: "hi", label: "Hindi" },
];

// import { useDispatch } from "react-redux";
const Header = ({
  handleFeedbackClick,
  RefreshSubjects,
  addbookOpen,
  setaddbookOpen,
  userAuth,
  RoutesClick,
  NcertClick,
  registerModal,
  setRegisterModal,
  activeTab,
  handleTabClick,
  studentregisterModal,
  setStudentRegisterModal,
  ParentregisterModal,
  setParentRegisterModal,
  TeacherregisterModal,
  AdminregisterModal,
  setAdminregisterModal,
  setTeacherregisterModal,
  selectedLang,
  setSelectedLang,
  setActiveIcon,
  bookFetchGo,
  setstandardArr,
  setuniquestandardArr,
  allCountries
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get("lang") || "en";

  const mediumData = ["655d8e94a22a464609a59c86", "656736d7374dcb026cf1cb5f"];

  const standardData = [
    "656736f4374dcb026cf1cc3c",
    "65606377a22a464609a7e9dd",
    "67347f3bb936274f58f2813e",
    "673325a9b936274f58eebf1d",
    "68c5358ac55d84a7148f7a0b",
  ];

  const subjectData = [
    "65673718374dcb026cf1cf77",
    "656aed73374dcb026cf73294",
    "656065d8a22a464609a7f05b",
    "65606992a22a464609a7fff8",
    "67382d27b936274f58fad007",
    "67458d5758b65ba6b08d87c6",
    "673445cdb936274f58f0a592",
    "673325b7b936274f58eec010",
    "68c535bdc55d84a7148f7bee",
    "68c535c7c55d84a7148f7d5f",
    "68c535d8c55d84a7148f7f13",
    "68c535cfc55d84a7148f7e77",
  ];

  console.log(allCountries,"allCountries");
  

  const [secondsPassed, setSecondsPassed] = React.useState(0);
  const [timerActive, setTimerActive] = React.useState(true);
  const UserProfileData = JSON.parse(localStorage.getItem("userData"));
  const UserProfileType = JSON.parse(localStorage.getItem("userType"));
  const [StudentAddbookModal, setStudentAddbookModal] = React.useState(false);
  const [TeacherAddbookModal, setTeacherAddbookModal] = React.useState(false);
  const [UserValidate, setUserValidate] = React.useState(false);
  const [selecteduserId, setselecteduserId] = React.useState("");
  const [UserValidateList, setUserValidateList] = React.useState({});
  const [selectedCountry, setselectedCountry] = React.useState("");

  const startTime = 60 * 2;
  const timeLeft = startTime - (secondsPassed % startTime);

  const minuteCount = ~~(timeLeft / 60);
  const secondsCount = timeLeft % 60;
  const countdown = `${minuteCount}:${secondsCount.toLocaleString("en-US", {
    minimumIntegerDigits: 2,
  })}`;

  const [isLoadingreg, setisLoadingreg] = useState(false);
  const [OtpModal, setOtpModal] = useState(false);
  const [roleName, setroleName] = useState("");
  const [isResend, setisResend] = useState(false);
  const [ForgotpwdModal, setForgotpwdModal] = useState(false);
  const [pwdModal, setPwdModal] = useState(false);

  const [routeModal, setRouteModal] = useState(false);
  const [ncertModal, setNcertModal] = useState(false);

  const [LoginModal, setLoginModal] = useState(false);
  const [LoginRoleModal, setLoginRoleModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpPwd, setOtpPwd] = useState("");
  const [button, setbutton] = useState();

  const [menuOpen, setMenuOpen] = useState(false);
  const [menuOpenContent, setMenuOpenContent] = useState(false);
  const [mediumarray, setmediumarray] = useState([]);
  const [stdarray, setstdarray] = useState([]);
  const [subarray, setsubarray] = useState([]);
  const [subteacherarray, setsubteacherarray] = useState([]);
  const [stdteacherarray, setstdteacherarray] = useState([]);
  const [usernamesuggestion, setusernamesuggestion] = useState([]);
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const [selectedSuggestionteach, setSelectedSuggestionteach] = useState(null);
  const [selectedSuggestionparent, setSelectedSuggestionparent] =
    useState(null);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [userdetails, setuserdetails] = useState([]);
  const [mobilenumber, setmobilenumber] = useState("");
  const [checkusernotify, setcheckusernotify] = useState("");
  const [checksuccessusernotify, setsuccesscheckusernotify] = useState("");
  const [loginmobilenumber, setloginmobilenumber] = useState("");
  const [registertype, setregistertype] = useState("");
  const notify = () => toast.error("Passwords does not match.");
  const successRegister = () => toast.success("Successfully Register.");
  const [checktecpwd, setchecktecpwd] = useState("");
  const [checkstupwd, setcheckstupwd] = useState("");
  const [checkparpwd, setcheckparpwd] = useState("");
  const [dataRegStatus, setdataRegStatus] = useState(false);
  const [userName, setUserName] = useState("");
  // const dispatch = useDispatch();

  const [menuOpenContent1, setMenuOpenContent1] = useState(false);

  const [showUserModal, setShowUserModal] = useState(false);
    const [logOutUserModal, setLogOutUserModal] = useState(false);

  const [userCredentials, setUserCredentials] = useState({
    userId: "",
    password: "",
    type: ""
  });

  const options = [
    [
      { value: "VIII", label: "VIII" },
      { value: "IX", label: "IX" },
      { value: "X", label: "X" },
      { value: "XI", label: "XI" },
      { value: "XII", label: "XII" },
    ],
    [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
      { value: "Others", label: "Others" },
    ],
    [
      { value: "Tamil", label: "Tamil" },
      { value: "English", label: "English" },
      // { value: "other", label: "other" },
    ],
    [
      { value: "Father", label: "Father" },
      { value: "Mother", label: "Mother" },
      { value: "Gaurdian", label: "Gaurdian" },
    ],
  ];
  // const options = [
  //     { value: "chocolate", label: "Chocolate" },
  //     { value: "strawberry", label: "Strawberry" },
  //     { value: "vanilla", label: "Vanilla" },
  // ];
  const selctGaurd = [
    { value: "Father", label: "Father" },
    { value: "Mother", label: "Mother" },
    { value: "Guardian", label: "Guardian" }, // Corrected typo here
  ];

  // Regular expression to allow only letters (a-z, A-Z) and spaces
  // The `i` flag makes it case-insensitive
  const regexName = /^[a-zA-Z\s]{1,15}$/;

  const regexNumber = /^[0-9\s]+$/;

  const MobCorrect = /^\d+$/;

  const userIdregex = /^[A-Za-z0-9]{4,20}$/;

  const pswdregex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{6,}$/;

  useEffect(() => {
    if(allCountries?.length > 0){
      setselectedCountry(allCountries[0]);
    }
  },[allCountries]);

  useEffect(() => {
    console.log(timeLeft, "timer");
    if (OtpModal || ForgotpwdModal) {
      if (timerActive && timeLeft > 1) {
        const timer = setInterval(() => {
          console.log(secondsPassed, "timer");
          setSecondsPassed((sp) => sp + 1);
        }, 1000);

        return () => clearInterval(timer);
      } else if (timeLeft === 1) {
        // setTimerActive(false);
        setTimeout(() => {
          setTimerActive(false);
        }, 1000);
      }
    }
  }, [OtpModal, ForgotpwdModal, timerActive, timeLeft]);

  const navigate = useNavigate();
  const [gaurdShow, setGaurdShow] = useState(false);
  const [userdetailshow, setuserdetailshow] = useState(false);

  const guardOnChange = (e) => {
    if (e.value === "Father" || e.value === "Mother") {
      setGaurdShow(false);
    } else if (e.value === "Guardian") {
      // setparentState({
      //     gender: "",
      // });
      setGaurdShow(true);
    }
  };
  const [registerStudDis, setRegisterStudDis] = useState(false);
  const [registerTeachDis, setRegisterTeachDis] = useState(false);
  const [pincode, setPincode] = useState("");
  const [countryId, setCountryId] = useState([]);
  const [countryName, setCountryName] = useState("");
  const [stateName, setStateName] = useState("");
  const [stateList, setStateList] = useState([]);
  const [showStateSuggestion, setShowStateSuggestion] = useState(false);

  const stateWrapperRef = useRef(null);

  const GetStateName = async (country, search) => {
    try {
      const res = await getStateName(country, search);
      if (res.success === true) {
        setStateList(res.data);
        setShowStateSuggestion(true);
      } else {
        setStateList([]);
        setShowStateSuggestion(false);
      }
    } catch (err) {
      console.error("Error fetching state name:", err);
    }
  };

  const handleStateChange = (e) => {
    const val = e.target.value;
    setStateName(val);
    if (val.length >= 2) {
      GetStateName(countryName.label, val);
    } else {
      setShowStateSuggestion(false);
      setStateList([]);
    }
  };

  const handleSelectState = (name) => {
    setStateName(name);
    setShowStateSuggestion(false);
  };

  const [cityName, setCityName] = useState("");
  const [cityList, setcityList] = useState([]);
  const [showcitySuggestion, setShowcitySuggestion] = useState(false);

  const cityWrapperRef = useRef(null);

  const GetcityName = async (state, search) => {
    try {
      const res = await getcityName(state, search);
      if (res.success === true) {
        setcityList(res.data);
        setShowcitySuggestion(true);
      } else {
        setcityList([]);
        setShowcitySuggestion(false);
      }
    } catch (err) {
      console.error("Error fetching city name:", err);
    }
  };

  const handlecityChange = (e) => {
    const val = e.target.value;
    setCityName(val);
    if (val.length >= 2) {
      GetcityName(stateName, val);
    } else {
      setShowcitySuggestion(false);
      setcityList([]);
    }
  };

  const handleSelectcity = (name) => {
    setCityName(name);
    setShowcitySuggestion(false);
  };
  const [areaName, setAreaName] = useState("");
  const [areaList, setareaList] = useState([]);
  const [showareaSuggestion, setShowareaSuggestion] = useState(false);

  const areaWrapperRef = useRef(null);

  const GetAreaName = async (city, search) => {
    try {
      const res = await getareaname(city, search);
      if (res.success === true) {
        setareaList(res.data);
        setShowareaSuggestion(true);
      } else {
        setareaList([]);
        setShowareaSuggestion(false);
      }
    } catch (err) {
      console.error("Error fetching area name:", err);
    }
  };

  const handleareaChange = (e) => {
    const val = e.target.value;
    setAreaName(val);
    if (val.length >= 2) {
      GetAreaName(cityName, val);
    } else {
      setShowareaSuggestion(false);
      setareaList([]);
    }
  };

  const handleSelectarea = (name) => {
    setAreaName(name);
    setShowareaSuggestion(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        areaWrapperRef.current &&
        !areaWrapperRef.current.contains(event.target)
      ) {
        setShowareaSuggestion(false);
      }
      if (
        cityWrapperRef.current &&
        !cityWrapperRef.current.contains(event.target)
      ) {
        setShowcitySuggestion(false);
      }
      if (
        stateWrapperRef.current &&
        !stateWrapperRef.current.contains(event.target)
      ) {
        setShowStateSuggestion(false);
      }
      if (
        stateSchoolWrapperRef.current &&
        !stateSchoolWrapperRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
      }
      if (
        stateSchoolTeacherWrapperRef.current &&
        !stateSchoolTeacherWrapperRef.current.contains(event.target)
      ) {
        setShowSuggestionsTeacher(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [areaData, setAreaData] = useState([]);
  const [areaSingleData, setAreaSingleData] = useState(false);

  const [viewAddressField, setViewAddressField] = useState(false);

  const [addressDis, setAddressDis] = useState(true);

  const GetCountryByPincode = async () => {
    try {
      let res = await getcountriesbyPincode();
      if (res.success === true) {
        const data = res.data.map((x) => ({
          value: x.country,
          label: x.country,
        }));
        setCountryId(data);
      } else {
        setCountryId([]);
        toast.error(res.error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const suggestionRef = useRef(null);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       suggestionRef.current &&
  //       !suggestionRef.current.contains(event.target)
  //     ) {
  //       setShowcitySuggestion(false);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  const handlePincodeChange = async (e) => {
    const value = e.target.value;

    const regex = /^[0-9]{0,6}$/;
    if (value !== "" && !regexNumber.test(value)) return;
    if(value?.length > 8) return;
    setPincode(value);
    if(selectedCountry?.dialingCode === "+91"){
      if (value.length < 6) {
        setCountryName("");
        setStateName("");
        setCityName("");
        setAreaName("");
        setAreaSingleData(true);
        setViewAddressField(false);
        setAddressDis(true);
      }
      if (value.length === 6) {
        setViewAddressField(true);
        setAddressDis(false);
        try {
          const bod = {
            postalCode: value,
          };

          let res = await postalPincode(bod);

          if (res.status === "SUCCESS" && res.data?.length > 0) {
            const info = res.data[0];
            setCountryName(info?.countryName ? info?.countryName : "");
            setStateName(info?.stateName ? info?.stateName : "");
            setCityName(info?.cityName ? info?.cityName : "");
            setAreaSingleData(false);
            setAddressDis(true);
            if (info?.areaName?.length === 1) {
              setAreaSingleData(true);
              setAreaName(info?.areaName[0]);
            } else if (info?.areaName?.length > 1) {
              setAreaSingleData(false);
              const formatted = info?.areaName.map((a) => ({
                label: a,
                value: a,
              }));
              setAreaData(formatted);
              setAreaName("");
            }
          } else {
            toast.error("Please enter valid pincode");
            setPincode("");
            setViewAddressField(true);
            setAreaSingleData(true);
            setAddressDis(false);
            GetCountryByPincode();
          }
        } catch (err) {
          console.error("API Error:", err);
          toast.error("Api is Not Working");
        }
      }
    } else {
      setCountryName("");
      setStateName("");
      setCityName("");
      setAreaName("");
      setAreaSingleData(true);
      setViewAddressField(false);
      setAddressDis(true);
    }
  };

  const DataSuggestion = [
    {
      name: "SAkashpandurangan07",
    },
    {
      name: "SAkashpandurangan72",
    },
    {
      name: "SAkashpandurangan7299",
    },
  ];

  const [studentClass, setStudentClass] = useState("");
  const [teacherClass, setTeacherClass] = useState("");
  const classList = [
    { value: "Class 1", label: "Class 1" },
    { value: "Class 6", label: "Class 6" },
    { value: "Class 12", label: "Class 12" },
  ];

  const [state, setState] = useState({
    firstName: "",
    lastName: "",
    birth: "",
    gender: "",
    number: "",
    schoolName: "",
    MediumInstruction: "",
    Standard: [],
    Subject: [],
    user: "",
    pwd: "",
    confirmPwd: "",
    suggestion: false,
    suggestionCard: false,
  });

  const [schoolList, setSchoolList] = useState([]); // suggestion data
  const [showSuggestions, setShowSuggestions] = useState(false);

  const stateSchoolWrapperRef = useRef(null);

  const GetSchoolName = async (search) => {
    try {
      const res = await getInstitutionName(search); // same API
      if (res.success === true) {
        setSchoolList(res.data);
        setShowSuggestions(true);
        setState((prev) => ({ ...prev, suggestion: true }));
      } else {
        setShowSuggestions(false);
        setSchoolList([]);
      }
    } catch (err) {
      console.error("Error fetching school name:", err);
    }
  };

  const handleSchoolChange = (e) => {
    const val = e.target.value;
    setState((prev) => ({ ...prev, schoolName: val }));

    if (val.length >= 2) {
      GetSchoolName(val);
    } else {
      setState((prev) => ({ ...prev, suggestion: false }));
      setShowSuggestions(false);
      setSchoolList([]);
    }
  };

  const handleSelectSchool = (name) => {
    setState((prev) => ({
      ...prev,
      schoolName: name,
    }));
    setShowSuggestions(false);
  };

  console.log(state.Standard, "qwerty");

  const [stateTeacher, setStateTeacher] = useState({
    firstName: "",
    lastName: "",
    birth: "",
    gender: "",
    number: "",
    schoolName: "",
    MediumInstruction: [],
    Standard: [],
    Subject: [],
    user: "",
    pwd: "",
    confirmPwd: "",
    suggestion: false,
    suggestionCard: false,
  });

  const [schoolListTeacher, setSchoolListTeacher] = useState([]); // suggestion data
  const [showSuggestionsTeacher, setShowSuggestionsTeacher] = useState(false);

  const stateSchoolTeacherWrapperRef = useRef(null);

  const GetSchoolNameTeacher = async (search) => {
    try {
      const res = await getInstitutionName(search); // same API
      if (res.success === true) {
        setSchoolListTeacher(res.data);
        setShowSuggestionsTeacher(true);
        setState((prev) => ({ ...prev, suggestion: true }));
      } else {
        setShowSuggestionsTeacher(false);
        setSchoolListTeacher([]);
      }
    } catch (err) {
      console.error("Error fetching school name:", err);
    }
  };

  const handleSchoolChangeTeacher = (e) => {
    const val = e.target.value;
    setStateTeacher((prev) => ({ ...prev, schoolName: val }));

    if (val.length >= 2) {
      GetSchoolNameTeacher(val);
    } else {
      setStateTeacher((prev) => ({ ...prev, suggestion: false }));
      setShowSuggestionsTeacher(false);
      setSchoolListTeacher([]);
    }
  };

  const handleSelectSchoolTeacher = (name) => {
    setStateTeacher((prev) => ({
      ...prev,
      schoolName: name,
    }));
    setShowSuggestionsTeacher(false);
  };

  // const [parentState, setparentState] = useState({
  //   firstName: "",
  //   lastName: "",
  //   birth: "",
  //   number: "",
  //   schoolName: "",
  //   Mr: [],
  //   StudentId: "",
  //   user: "",
  //   pwd: "",
  //   confirmPwd: "",
  //   suggestion: false,
  //   suggestionCard: false,
  // });

  const [LoginState, setLoginState] = useState({
    user: "",
    pwd: "",
  });

  const [enterPwd, setEnterPwd] = useState({
    pwd: "",
    confirmPwd: "",
  });

  const emptyStateParent = () => {
    setparentState({
      firstName: "",
      lastName: "",
      birth: "",
      number: "",
      schoolName: "",
      Mr: [],
      StudentId: "",
      user: "",
      pwd: "",
      confirmPwd: "",
      relation: "",
      gender: "",
      StudentId: "",
    });
    setEmail("");
    setselectedCountry("");
    setOtp("");
    setuserdetails([]);
    setGaurdShow(false);
    setsuccesscheckusernotify("");
    setcheckparpwd("");
  };

  const emptyState = () => {
    setState({
      firstName: "",
      lastName: "",
      birth: "",
      gender: [],
      number: "",
      schoolName: "",
      MediumInstruction: [],
      Standard: [],
      Subject: "",
      user: "",
      pwd: "",
      confirmPwd: "",
    });
    setEmail("");
    setselectedCountry("");
    setOtp("");
    setStudentClass("")
    setSelectedSubjects([]);
    setsubarray([]);
    setsuccesscheckusernotify("");
    setcheckstupwd("");
  };

  const emptyStateTeacher = () => {
    setStateTeacher({
      firstName: "",
      lastName: "",
      birth: "",
      gender: [],
      number: "",
      schoolName: "",
      MediumInstruction: [],
      Standard: [],
      Subject: "",
      user: "",
      pwd: "",
      confirmPwd: "",
    });
    setEmail("");
    setselectedCountry("");
    setOtp("");
    setTeacherClass("")
    setsubteacherarray([]);
    setsuccesscheckusernotify("");
    setchecktecpwd("");
  };
  const secretKey = "KampusNcrt";
  const key = "KPOSTKatBooks#$*(@#)!!";
  useEffect(() => {
    console.log(window.location.pathname, "pathname");
    // if(window.location.pathname==="/"){
    getMediumFunc();
    // }
    if(window.location.pathname=== "/user/register" &&
      (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "")
    ){
      setRegisterModal(true);
      setMenuOpen(false);
      setMenuOpenContent(false);
    }
  }, []);

  const [parentState, setparentState] = useState({
    firstName: "",
    lastName: "",
    birth: "",
    number: "",
    schoolName: "",
    relation: "",
    gender: "",
    StudentId: "",
    user: "",
    pwd: "",
    confirmPwd: "",
    suggestion: false,
    suggestionCard: false,
    checkvalue: false,
  });

  const [email, setEmail] = useState("");
  const [emailError, setemailError] = useState("");

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    // simple email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (value && !emailRegex.test(value)) {
      setemailError("Please enter a valid email ID");
    } else {
      setemailError("");
    }
  };

  const isFormValid = () => {
    // Check if all required fields are filled
    return Object.values(state).every((value) => Boolean(value));
  };

  const isFormValidLogin = () => {
    // Check if all required fields are filled
    return Object.values(LoginState).every((value) => Boolean(value));
  };

  const isFormValidNewPwd = () => {
    // Check if all required fields are filled
    return Object.values(enterPwd).every((value) => Boolean(value));
  };

  const isFormValidTeacher = () => {
    // Check if all required fields are filled
    return Object.values(stateTeacher).every((value) => Boolean(value));
  };

  // const isFormValidParent = () => {
  // Check if all required fields are filled
  //   return Object.values(parentState).every((value) => Boolean(value));
  // };

  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [showAllSubjects, setShowAllSubjects] = useState(false);

  const handleConfirmPasswordChangeTec = (e) => {
    const newConfirmPwd = e.target.value;
    setStateTeacher({ ...stateTeacher, confirmPwd: newConfirmPwd });
    // if (stateTeacher.pwd && newConfirmPwd !== stateTeacher.pwd) {
    //     setchecktecpwd('Passwords do not match');
    // } else {
    //     setchecktecpwd('');
    // }
  };
  const handleConfirmPasswordChangeStu = (e) => {
    const newConfirmPwd = e.target.value;
    setState({ ...state, confirmPwd: newConfirmPwd });
    // if (state.pwd && newConfirmPwd !== state.pwd) {
    //     setcheckstupwd('Passwords do not match');
    // } else {
    //     setcheckstupwd('');
    // }
  };
  const handleConfirmPasswordChangePar = (e) => {
    const newConfirmPwd = e.target.value;
    setparentState({ ...parentState, confirmPwd: newConfirmPwd });
    // if (parentState.pwd && newConfirmPwd !== parentState.pwd) {
    //     setcheckparpwd('Passwords do not match');
    // } else {
    //     setcheckparpwd('');
    // }
  };
  const handleCheckboxChange = (selectedSubject) => {
    const { label, value } = selectedSubject;

    setSelectedSubjects((prevSelectedSubjects) => {
      const isAlreadySelected = prevSelectedSubjects.some(
        (subject) => subject.label === label && subject.value === value
      );

      if (isAlreadySelected) {
        // If already selected, remove the subject
        return prevSelectedSubjects.filter(
          (subject) => !(subject.label === label && subject.value === value)
        );
      } else {
        // If not selected, add the subject
        return [...prevSelectedSubjects, { label, value }];
      }
    });
  };

  const [loginProfiles, setLoginProfiles] = useState(false);

  const loginuserfunc = async () => {
    console.log(isNaN(LoginState.user), "isNaN");
    try {
      let bod = {
        userId: selecteduserId
          ? selecteduserId
          : roleName === "Student"
          ? isNaN(LoginState.user)
            ? `S${LoginState.user}`
            : LoginState.user
          : roleName === "Teacher"
          ? isNaN(LoginState.user)
            ? `T${LoginState.user}`
            : LoginState.user
          : LoginState.user,
        password: LoginState.pwd,
        role: roleName,
      };

      let res = await userlogin(bod);

      if (res?.success === true) {
        <Public isLogged={true} />;

        const encryptedMedium = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.medium),
          secretKey
        ).toString();
        const encryptedSubjects = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.subjects),
          secretKey
        ).toString();
        const encryptedStandard = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.standard),
          secretKey
        ).toString();
        const encryptedCode = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.code),
          secretKey
        ).toString();
        const encryptedUserID = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.userId),
          secretKey
        ).toString();
        const { firstName, lastName } = res.value;
        const username = `${firstName} ${lastName}`;
        setUserName(username);
        //   const userCode = res.value.code;g
        //   const userId = res.value.userId;
        localStorage.setItem("userID", encryptedUserID);
        localStorage.setItem("userCode", encryptedCode);
        localStorage.setItem("username", username);
        localStorage.setItem("feedback", res.feedback);
        localStorage.setItem("encryptedMedium", encryptedMedium);
        localStorage.setItem("encryptedSubjects", encryptedSubjects);
        localStorage.setItem("encryptedStandard", encryptedStandard);
        localStorage.setItem("token", res?.token);
        localStorage.setItem("IsUserAuth", true);
        localStorage.setItem("userData", JSON.stringify(res?.value));
        localStorage.setItem("userType", JSON.stringify(res?.value.userTypeId));
        // sessionStorage.setItem('token', res?.token);
        sessionStorage.setItem("user", JSON.stringify(res?.value));

        toast.success(res?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        <Private isLogged={true} />;
        setLoginModal(false);
        setLoginState("");
        //  window.location.href = "/bookview";
        navigate("/bookview");
        setroleName("");
      } else {
        // console.log(res.error, res, "testtstst")
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleLogout = () => {
    setLogOutUserModal(false);
    // const currentVersion = localStorage.getItem("app_version");
    setLoginProfiles(false);
    localStorage.removeItem("userID");
    localStorage.removeItem("userCode");
    localStorage.removeItem("username");
    localStorage.removeItem("encryptedMedium");
    localStorage.removeItem("encryptedSubjects");
    localStorage.removeItem("encryptedStandard");
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    localStorage.removeItem("IsUserAuth");
    localStorage.removeItem("userType");
    localStorage.removeItem("username");
    localStorage.removeItem("feedback");
    // localStorage.clear();
    // localStorage.setItem("app_version", currentVersion);
    navigate("/");
  };
  const handleLogoutAdmin = () => {
    setLogOutUserModal(false);
    // const currentVersion = localStorage.getItem("app_version");
    setLoginProfiles(false);
    localStorage.removeItem("userID");
    localStorage.removeItem("userCode");
    localStorage.removeItem("username");
    localStorage.removeItem("encryptedMedium");
    localStorage.removeItem("encryptedSubjects");
    localStorage.removeItem("encryptedStandard");
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    localStorage.removeItem("IsUserAuth");
    localStorage.removeItem("userType");
    localStorage.removeItem("username");
    localStorage.removeItem("feedback");
    // localStorage.clear();
    // localStorage.setItem("app_version", currentVersion);
    navigate("/ad-login");
  };

  const handleFeedbackRedirect = () => {
    setLogOutUserModal(false);
      navigate("/bookview", { state: { openFeedback: true } }); // Pass state
  };

  const logOutContent = (
  <div className="d-flex flex-column align-items-center justify-content-center p-4" style={{ maxWidth: '400px' }}>
    {/* Feedback Icon */}
    <div className="mb-3">
      <VscFeedback size={50} color="#4A90E2" />
    </div>
    
    {/* Heading */}
    <h5 className="text-center mb-3 fw-bold">
      We'd really appreciate your quick feedback before you log out!
    </h5>
    
    {/* Description */}
    <p className="text-center text-muted fw-semibold mb-4">
      It only takes a few seconds and helps us make things better for you.
    </p>
    
    {/* Question */}
    <p className="text-center fw-semibold mb-4">
      Would you like to share your feedback now?
    </p>
    
    {/* Buttons */}
    <div className="d-flex gap-3 w-100">
      <button 
        className="btn btn-primary flex-fill"
        onClick={handleFeedbackRedirect}
      >
        Yes
      </button>
      <button 
        className="btn btn-secondary flex-fill"
        onClick={handleLogout}
      >
        Maybe later
      </button>
    </div>
  </div>
  );

  const FeedBackView = localStorage.getItem("feedback");
  const LoginUserType = JSON.parse(localStorage.getItem("userType"));
  console.log(LoginUserType,"qwqwqwq")

  const handleLogoutView = () => {
    if (FeedBackView === "true") {
      handleLogout();
    }else if (LoginUserType.usertype === "Admin"){
      handleLogoutAdmin();
    }
    else{
      setLogOutUserModal(true);
    }
  };

  const handleclickMykatbook = () => {
    setLoginProfiles((prev) => !prev);
    navigate("/bookview");
  };

  const dropdownRef = useRef(null);

  const handleclick = (event) => {
    event.stopPropagation();
    setLoginProfiles((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setLoginProfiles(false);
      }
    };

    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const getMediumFunc = async () => {
    try {
      let res = await getmedium();
      console.log("ddddddddddddd", res);
      if (res.success) {
        let data = res.data
          .filter((medium) => medium.variableName !== "اردو میڈیم")
          .map((medium) => ({
            label: medium.variableName,
            value: medium._id,
          }));

        console.log(data, "ddddddddddddd");
        setmediumarray(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleStudentStandardChange = () => {};

  const handleaddbookMediumChange = async (e) => {
    if (e.length === 0) {
      setState({ ...state, Standard: "", MediumInstruction: e });
    } else {
      var medium_data = e.map((item) => {
        return item.value;
      });
      let bod = {
        variableIds: medium_data,
      };
      let res = await getstandardbyMID(bod, "Student");
      console.log(res, "aftersuccess");
      if (res?.success === true) {
        let resStadData = res.data.filter(
          (ss) =>
            String(ss.variableName) ===
            String(UserProfileData.standard[0]?.variableName)
        );
        let data;
        data = resStadData.map((std) => ({
          label: std.variableName + " Std - " + std.class + "",
          value: std._id,
          variableN: std.variableName,
        }));
        setstdarray(data);
        setstdteacherarray(data);
        getsubjectlist(data);
      }
      setState({ ...state, MediumInstruction: e, Standard: stdarray });
    }
  };

  const handleMediumChange = async (e) => {
    console.log(e, "Student Data");
    if (e.length === 0) {
      setState({ ...state, Standard: "", MediumInstruction: e });
    } else {
      setState({ ...state, MediumInstruction: e });
    }
    if (e.length > 0) {
      getStustandard(e);
    }
  };

  const getStustandard = async (mid, type) => {
    var medium_data = mid.map((item) => {
      return item.value;
    });

    console.log(medium_data, "ddddddddddddd");

    try {
      // let bod = {
      //     "variableIds": [
      //         mid.value
      //     ]
      // }
      let bod = {
        variableIds: medium_data,
      };
      let res = await getstandardbyMID(bod, type);

      if (res?.success === true) {
        console.log(res, "aftersuccess");
        console.log(userAuth, "aftersuccess");
        const allowedClasses = ["Class 1", "Class 6", "Class 12"];

        let data;
        if (userAuth === "true") {
          let resStadData = res.data.filter(
            (ss) =>
              allowedClasses.includes(ss.variableName) &&
              String(ss.variableName) ===
                String(UserProfileData.standard[0]?.variableName)
          );
          console.log(resStadData, "aftersuccess");
          data = resStadData
            .sort(
              (a, b) =>
                allowedClasses.indexOf(a.variableName) -
                allowedClasses.indexOf(b.variableName)
            )
            .map((std) => ({
              label: std.variableName + " Std - " + std.class + "",
              value: std._id,
              variableN: std.variableName,
            }));
        } else {
          data = res.data
            .filter((std) => allowedClasses.includes(std.variableName))
            .sort(
              (a, b) =>
                allowedClasses.indexOf(a.variableName) -
                allowedClasses.indexOf(b.variableName)
            )
            .map((std) => ({
              label: std.variableName + " Std - " + std.class + "",
              value: std._id,
              variableN: std.variableName,
            }));
        }
        console.log(data, "aftersuccess");
        setstdarray(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleTeaMediumChange = async (e) => {
    console.log(e, "Student Data");
    if (e.length === 0) {
      setStateTeacher({ ...stateTeacher, MediumInstruction: e, Standard: [] });
    } else {
      setStateTeacher({ ...stateTeacher, MediumInstruction: e });
    }
    if (e.length > 0) {
      getTeastandard(e);
    }
  };

  const getTeastandard = async (mid, type) => {
    var medium_data = mid.map((item) => {
      return item.value;
    });

    try {
      // let bod = {
      //     "variableIds": [
      //         mid.value
      //     ]
      // }
      let bod = {
        variableIds: medium_data,
      };
      let res = await getstandardbyMID(bod, type);

      if (res?.success === true) {
        console.log(res, "aftersuccess");
        const allowedClasses = ["Class 1", "Class 6", "Class 12"];

        let data = res.data
          .filter((std) => allowedClasses.includes(std.variableName))
          .sort(
            (a, b) =>
              allowedClasses.indexOf(a.variableName) -
              allowedClasses.indexOf(b.variableName)
          )
          .map((std) => ({
            label: std.variableName + " Std - " + std.class + "",
            value: std._id,
          }));
        setstdteacherarray(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getsubjectlist = async (sid, type, stdtype) => {
    console.log(sid, stdtype, "testesid");

    var standard_data = sid.map((item) => {
      return item.value;
    });

    console.log(standard_data, "ddddddddddddd");

    try {
      if (stdtype !== "teacherstd") {
        // let bod = {
        //     "variableIds": [
        //         sid.value
        //     ]
        // }
        let bod = {
          variableIds: standard_data,
        };
        let res = await getstandardbyMID(bod, type);

        if (res?.success === true) {
          let subjectMap = {};

          res.data.forEach((subjectItem) => {
            // Use the class name as the key
            const className = subjectItem.class; // This gives "Class 4" etc.

            if (!subjectMap[className]) {
              subjectMap[className] = [];
            }
            subjectMap[className].push({
              label: subjectItem.variableName,
              value: subjectItem._id,
              variableName: subjectItem.variableName,
              class: className,
            });
          });

          setsubarray(subjectMap);

          // setsubarray(res.data);
        }
      } else {
        console.log(stateTeacher.Standard, sid, "stateTeacher");
        const Stdteachervalue = sid.map((standard) => standard.value);
        console.log(Stdteachervalue, "stdbod");
        // const Stdteacherlabel = sid.map(standard => standard.label);
        let bod = {
          variableIds: Stdteachervalue,
        };
        console.log(bod, "stdbod");
        let res = await getstandardbyMID(bod, type);

        // if (res?.success === true) {
        //     console.log(res.data, "aftersuccessstd");
        //     // const subjectsForSid = res.data[Stdteacherlabel];

        //     // let data = subjectsForSid.map(std => ({
        //     //     label: std.variableName,
        //     //     value: std._id,
        //     // }));

        //     // setsubteacherarray(data);
        // }
        if (res?.success === true) {
          //     const allVariables = Object.values(res.data)
          //     .map(subjects => subjects.map(subject => ({
          //         label: subject.variableName,
          //         value: subject._id,
          //     })))
          //     .flat();

          console.log(res.data, "allveriable");
          setsubteacherarray(res.data);
        } else {
          setsubteacherarray([]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const checkuseridfun = async (type) => {
    let body;

    if (type === "student") {
      body = `S${state.user}`;
    } else if (type === "parent") {
      // body = parentState.user;
      body =
        parentState.relation.value === "Father"
          ? `F${parentState.user}`
          : parentState.relation.value === "Mother"
          ? `M${parentState.user}`
          : parentState.relation.value === "Guardian"
          ? `G${parentState.user}`
          : `${parentState.user}`;
    } else {
      body = `T${stateTeacher.user}`;
    }
    try {
      let res = await checkuserid(body);

      if (res?.success === true) {
        setsuccesscheckusernotify(res?.message);
        setcheckusernotify("");
      } else {
        setsuccesscheckusernotify("");
        setcheckusernotify(res?.error);
        if (type === "student") {
          setState({
            ...state,
            suggestion: true,
          });
        } else if (type === "parent") {
          setparentState({
            ...parentState,
            suggestion: true,
          });
        } else {
          setStateTeacher({
            ...stateTeacher,
            suggestion: true,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const useridsuggestionlist = async (type) => {
    console.log(stateTeacher, "stateTeacher");
    console.log(type, "stateTeacher");
    try {
      let bod;

      if (type === "student") {
        bod = {
          firstName: state.firstName,
          lastName: state.lastName,
        };
      } else if (type === "parent") {
        bod = {
          firstName: parentState.firstName,
          lastName: parentState.lastName,
        };
      } else {
        bod = {
          firstName: stateTeacher.firstName,
          lastName: stateTeacher.lastName,
        };
      }
      let res = await useridsuggestion(bod);

      if (res?.success === true) {
        setusernamesuggestion(res.data);
        console.log(res, "useridsugg");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleTeacherstdChangeForAddBook = (selectedOptions) => {
    setStateTeacher({ ...stateTeacher, Standard: selectedOptions });
    getsubjectlist(selectedOptions, "teacher", "teacherstd");
  };

  const handleTeacherstdChange = (selectedOptions) => {
    setSelectedSubjectsTeach([]);
    setStateTeacher({ ...stateTeacher, Standard: selectedOptions });
    getsubjectlist(selectedOptions, "teacher", "teacherstd");
  };
  const handleStudentSubjectChange = (selectedOptions) => {
    setState({ ...state, Subject: selectedOptions });
  };
  const addTeacher = async () => {
    console.log(selectedSubjectsTeach, "testsub");
    const medium_Studata = stateTeacher.MediumInstruction.map((item) => {
      return item.value;
    });
    const Standardidarr = stateTeacher.Standard.map((std) => std.value);
    const selectedSubjectIds = Object.keys(selectedSubjectsTeach).filter(
      (subjectId) => selectedSubjectsTeach[subjectId]
    );
    try {
      let bod = {
        firstName: stateTeacher.firstName.trim(),
        lastName: stateTeacher.lastName.trim(),
        mobileNo: stateTeacher.number,
        gender: stateTeacher.gender.value,
        schoolName: stateTeacher.schoolName,
        medium: mediumData,
        standard: standardData,
        userId: `T${stateTeacher.user.toLowerCase()}`,
        password: stateTeacher.pwd,
        subjects: subjectData,
        email: email,
        className: teacherClass.label,
        countryId: selectedCountry?.value,
        addressDetails: {
          pincode: pincode,
          area: areaName?.label ? areaName?.label : areaName,
          city: cityName,
          state: stateName,
          country: countryName?.label ? countryName?.label : countryName,
        },
      };
      let res = await createTeacher(bod);
      if (res?.success === true) {
        // toast.success(res?.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        setOtpModal(false);
        setOtp("");
        setRegisterModal(false);
        setTeacherregisterModal(false);
        emptyStateTeacher();
        setOtpModal(false);
        console.log(res.message, "message");
        setroleName("");
        setTeacherClass("");

        if (res?.data) {
          setUserCredentials({
            userId: res.data.userId,
            password: res.data.password,
            type: "Teacher"
          });
          setShowUserModal(true);
        }
      } else {
        //toast.error(<Danger body={"Something error in create API"} />);
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setRegisterModal(false);
        setTeacherregisterModal(true);
        console.log(res.error, "message");
      }
    } catch (e) {
      //console.log(e);
    }
  };

  const Adminregisterfunc = async () => {
    const medium_Studata = stateTeacher.MediumInstruction.map((item) => {
      return item.value;
    });
    const Standardidarr = stateTeacher.Standard.map((std) => std.value);
    const selectedSubjectIds = Object.keys(selectedSubjectsTeach).filter(
      (subjectId) => selectedSubjectsTeach[subjectId]
    );
    try {
      let bod = {
        firstName: stateTeacher.firstName.trim(),
        lastName: stateTeacher.lastName.trim(),
        mobileNo: stateTeacher.number,
        dateOfBirth: stateTeacher.birth,
        gender: stateTeacher.gender.value,
        schoolName: stateTeacher.schoolName,
        medium: medium_Studata,
        standard: Standardidarr,
        userId: `A${stateTeacher.user}`,
        password: stateTeacher.pwd,
        subjects: Object.keys(selectedSubjectsTeach),
        email: email,
        addressDetails: {
          pincode: pincode,
          area: areaName.label,
          city: cityName,
          state: stateName,
          country: countryName,
        },
      };
      let res = await createAdmin(bod);
      if (res?.success === true) {
        toast.success(res?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setRegisterModal(false);
        setAdminregisterModal(false);
        emptyStateTeacher();
        setOtpModal(false);
        console.log(res.message, "message");
        setroleName("");
      } else {
        //toast.error(<Danger body={"Something error in create API"} />);
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setRegisterModal(false);
        setAdminregisterModal(true);
        console.log(res.error, "message");
      }
    } catch (e) {
      //console.log(e);
    }
  };

  const updateBooks = async (type) => {
    console.log(Object.keys(selectedSubjects), "JJJJJJJJJJJJJJ");
    console.log(Object.keys(selectedSubjectsTeach), "JJJJJJJJJJJJJJ");
    // let Subjectidarr;
    // if (type === "student") {
    //   Subjectidarr = selectedSubjects.map((subject) => subject.value);
    // }
    try {
      //   let bod = {
      //     bookIds:
      //       type === "student"
      //         ? Subjectidarr
      //         : Object.keys(selectedSubjects).length <
      //           Object.keys(selectedSubjectsTeach).length
      //         ? Object.keys(selectedSubjectsTeach)
      //         : [],
      //   };
      let bod = {
        bookIds:
          Object.keys(selectedSubjects).length <
          Object.keys(selectedSubjectsTeach).length
            ? Object.keys(selectedSubjectsTeach)
            : [],
      };

      let res = await addStudentBook(UserProfileData?._id, bod);
      if (res?.success === true) {
        setstandardArr(res.value.standard);
        if (res?.value?.standard?.length > 0) {
          const uniquestandardData = [
            ...new Map(
              res?.value?.standard?.map((item123) => [
                item123?.variableName,
                item123,
              ])
            ).values(),
          ];
          setuniquestandardArr(uniquestandardData);
        }

        const encryptedMedium = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.medium),
          secretKey
        ).toString();
        const encryptedSubjects = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.subjects),
          secretKey
        ).toString();
        const encryptedStandard = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.standard),
          secretKey
        ).toString();
        const encryptedCode = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.code),
          secretKey
        ).toString();
        const encryptedUserID = CryptoJS.AES.encrypt(
          JSON.stringify(res.value.userId),
          secretKey
        ).toString();
        const { firstName, lastName } = res.value;
        const username = `${firstName} ${lastName}`;
        //   const userCode = res.value.code;
        //   const userId = res.value.userId;
        localStorage.setItem("userID", encryptedUserID);
        localStorage.setItem("userCode", encryptedCode);
        localStorage.setItem("username", username);
        localStorage.setItem("encryptedMedium", encryptedMedium);
        localStorage.setItem("encryptedSubjects", encryptedSubjects);
        localStorage.setItem("encryptedStandard", encryptedStandard);
        // localStorage.setItem("token", res?.token);
        // localStorage.setItem("IsUserAuth", true);
        localStorage.setItem("userData", JSON.stringify(res?.value));
        localStorage.setItem("userType", JSON.stringify(res?.value.userTypeId));
        // sessionStorage.setItem('token', res?.token);
        sessionStorage.setItem("user", JSON.stringify(res?.value));

        toast.success(res?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        emptyState();
        RefreshSubjects(res.value.subjects.map((subject) => subject._id));
      } else {
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      setStudentAddbookModal(false);
      setTeacherAddbookModal(false);
    } catch (e) {
      console.log(e, "error");
    }
  };

  

  const addStudent = async () => {
    try {
      let bod = {
        firstName: state.firstName.trim(),
        lastName: state.lastName.trim(),
        mobileNo: state.number,
        gender: state.gender.value,
        schoolName: state.schoolName,
        medium: mediumData,
        standard: standardData,
        userId: `S${state.user.toLowerCase()}`,
        password: state.pwd,
        subjects: subjectData,
        email: email,
        className: studentClass.label,
        countryId: selectedCountry?.value,
        addressDetails: {
          pincode: pincode,
          area: areaName?.label ? areaName?.label : areaName,
          city: cityName,
          state: stateName,
          country: countryName?.label ? countryName?.label : countryName,
        },
      };
      console.log(bod, "testbod");
      let res = await createStudent(bod);
      if (res?.success === true) {
        // toast.success(res?.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        setOtpModal(false);
        setOtp("");
        setRegisterModal(false);
        setStudentRegisterModal(false);
        emptyState();
        setOtpModal(false);
        console.log(res.message, "message");
        setroleName("");
        setStudentClass("");

        if (res?.data) {
          setUserCredentials({
            userId: res.data.userId,
            password: res.data.password,
            type: "Student"
          });
          setShowUserModal(true);
        }
      } else {
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setRegisterModal(false);
        setStudentRegisterModal(true);
      }
    } catch (e) {
      console.log(e, "error");
    }
  };

  const userContent = (
    <div className="text-center">
      <div className="mb-3 User_Register_success">
        {userCredentials?.type === "Student" ? "Student registered successfully! 🎉" : userCredentials?.type === "Teacher" ? "Teacher registered successfully! 🎉" : ""}
      </div>
      <p className="User_Register_success_para">
        User ID: <strong>{userCredentials?.userId}</strong>
      </p>
      <p className="User_Register_success_para">
        Password: <strong>{userCredentials?.password}</strong>
      </p>
    </div>
  );

  const addParent = async () => {
    try {
      let bod = {
        firstName: parentState.firstName.trim(),
        lastName: parentState.lastName.trim(),
        mobileNo: parentState.number,
        dateOfBirth: parentState.birth,
        studentId: `S${parentState.StudentId}`,
        password: parentState.pwd,
        // userId: parentState.user,
        email: email,
        userId:
          parentState.relation.value === "Father"
            ? `F${parentState.user}`
            : parentState.relation.value === "Mother"
            ? `M${parentState.user}`
            : parentState.relation.value === "Guardian"
            ? `M${parentState.user}`
            : `P${parentState.user}`,
        gender:
          parentState.relation.value === "Father"
            ? "Male"
            : parentState.relation.value === "Mother"
            ? "Female"
            : parentState.relation.value === "Guardian"
            ? parentState.gender.value
            : "Male",
        relation: parentState.relation.value,
      };
      console.log(bod, "addparent");
      let res = await createParent(bod);
      if (res?.success === true) {
        toast.success(res?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setOtpModal(false);
        setOtp("");
        setuserdetailshow(false);
        setRegisterModal(false);
        setParentRegisterModal(false);
        emptyStateParent();
        setOtpModal(false);
        console.log(res.message, "message");
        setroleName("");
      } else {
        //toast.error(<Danger body={"Something error in create API"} />);
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setRegisterModal(false);
        setParentRegisterModal(true);
        //    setuserdetailshow(false);
        console.log(res.error, "message");
      }
    } catch (e) {
      console.log(e, "error");
    }
  };
  const handleSelectAll = () => {
    const allSubjects = Object.values(subarray)
      .flat()
      .map((x) => ({ label: x.label, value: x.value }));
    setSelectedSubjects(allSubjects);
  };

  const handleClearAll = () => {
    setSelectedSubjects([]);
  };

  const handleUserCheckboxChange = () => {
    setparentState((prevState) => ({
      ...prevState,
      checkvalue: !prevState.checkvalue,
    }));

    getuserdetailsbyId();
  };
  const handleButtonClick = () => {
    setShowAllSubjects(!showAllSubjects);
  };
  const getuserdetailsbyId = async (id) => {
    try {
      let body = `S${parentState.StudentId}`;

      let res = await getuseridDetails(body);
      if (res.success) {
        console.log(res.data, "getuserdata");
        setuserdetailshow(true);
        setuserdetails(res.data);
        // toast.success(res?.message, {
        //     position: toast.POSITION.TOP_RIGHT,
        // });
      } else {
        setuserdetailshow(false);
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const generateResendOTPfunc = async (type, regtype, role) => {
    try {
      const userInput = LoginState.user;
      const isMobileNumber = /^\d+$/.test(userInput);

      const mobileNumber =
        regtype === "Stu"
          ? state.number
          : regtype === "Par"
          ? parentState.number
          : regtype === "Tec"
          ? stateTeacher.number
          : userInput;
      let bod = {
        country: selectedCountry?.value,
        email: email,
        mobile: mobileNumber,
        type: type,
        role: role,
        userid: isMobileNumber ? null : userInput,
      };
      console.log(bod, "testbod");
      let res = await otpgenerate(bod);
      if (res?.success === true) {
        if(type === "registration"){
          setOtp("")
        }
        if(type === "reset"){
          setOtpPwd("")
        }
        // toast.success(res?.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        setloginmobilenumber(res.mobile);

        setroleName(role);
        setisResend(false);
      } else {
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      setisLoadingreg(false);
    } catch (e) {
      setisLoadingreg(false);
      console.log(e, "error");
    }
  };

  const generateResetOTPfunc = async (type, regtype, role) => {
    setisLoadingreg(true);
    try {
      const isMobileTrue = /^\d+$/.test(LoginState.user);
      const userInput =
        selecteduserId !== "" ? selecteduserId : (role === "Student" ? (isMobileTrue ? LoginState.user : `S${LoginState.user}`) : role === "Teacher" ? (isMobileTrue ? LoginState.user : `T${LoginState.user}`) : LoginState.user);
      const isMobileNumber = /^\d+$/.test(userInput);
      console.log(selecteduserId,"selecteduserId");
      console.log(userInput,"selecteduserId");
      const mobileNumber =
        regtype === "Stu"
          ? state.number
          : regtype === "Par"
          ? parentState.number
          : regtype === "Tec"
          ? stateTeacher.number
          : userInput;
      let bod = {
        mobileOrUserId: mobileNumber,
        role: role.toUpperCase(),
      };
      console.log(bod, "testbod");
      let res = await otpresetforUser(bod);
      if (res?.success === true) {
        // toast.success(res?.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        setloginmobilenumber(res?.mobile ? res?.mobile : res?.email ? res?.email : "");

        if (type === "reset") {
          setLoginModal(false);
          setForgotpwdModal(true);
        } else {
          setOtpModal(true);
        }
        setroleName(role);
      } else {
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setRegisterTeachDis(false)
        setRegisterStudDis(false)
      }
      setisLoadingreg(false);
    } catch (e) {
      setisLoadingreg(false);
      setRegisterTeachDis(false)
      setRegisterStudDis(false)
      console.log(e, "error");
    }
  };

  const generateOTPfunc = async (type, regtype, role) => {
    setisLoadingreg(true);
    try {
      const isMobileTrue = /^\d+$/.test(LoginState.user);
      const userInput =
        selecteduserId !== "" ? selecteduserId : (role === "Student" ? (isMobileTrue ? LoginState.user : `S${LoginState.user}`) : role === "Teacher" ? (isMobileTrue ? LoginState.user : `T${LoginState.user}`) : LoginState.user);
      const isMobileNumber = /^\d+$/.test(userInput);
      console.log(selecteduserId,"selecteduserId");
      console.log(userInput,"selecteduserId");
      const mobileNumber =
        regtype === "Stu"
          ? state.number
          : regtype === "Par"
          ? parentState.number
          : regtype === "Tec"
          ? stateTeacher.number
          : userInput;
      let bod = {
        countryId: selectedCountry?.value,
        email: email,
        mobileNo: mobileNumber,
        role: role.toUpperCase(),
        // userId: isMobileNumber
        //   ? null
        //   : role === "Student"
        //   ? `${userInput}`
        //   : role === "Teacher"
        //   ? `${userInput}`
        //   : userInput,
      };
      console.log(bod, "testbod");
      let res = await otpgenerateforRegister(bod);
      if (res?.success === true) {
        // toast.success(res?.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        setloginmobilenumber(res.mobile);

        if (type === "reset") {
          setLoginModal(false);
          setForgotpwdModal(true);
        } else {
          setOtpModal(true);
        }
        setroleName(role);
      } else {
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setRegisterTeachDis(false)
        setRegisterStudDis(false)
      }
      setisLoadingreg(false);
    } catch (e) {
      setisLoadingreg(false);
      setRegisterTeachDis(false)
      setRegisterStudDis(false)
      console.log(e, "error");
    }
  };

  const forgototpVerfication = async () => {
    try {
      let bod = {
        mobileOrMailId: loginmobilenumber,
        otp: otpPwd,
        type: "RESET",
        role: roleName.toUpperCase(),
      };

      let res = await otpverfication(bod);
      if (res?.success === true) {
        setForgotpwdModal(false);
        setPwdModal(true);
        setOtpPwd("");
      } else {
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (e) {
      console.log(e, "error");
    }
  };

  const userotpVerfication = async (type, regtype) => {
    try {
      let bod = {
        mobileOrMailId: selectedCountry?.dialingCode === "+91" ? mobilenumber : email,
        otp: otp,
        type: type,
        role: roleName.toUpperCase(),
      };
      console.log(bod, "testbod");
      let res = await otpverfication(bod);
      if (res?.success === true) {
        // toast.success(res?.message, {
        //     position: toast.POSITION.TOP_RIGHT,
        // });
        // setOtpModal(false);
        // setOtp("");
        setdataRegStatus(true);
        setRegisterStudDis(false);
        setRegisterTeachDis(false);
        registerAndVerify(regtype);
      } else {
        setRegisterStudDis(false);
        setRegisterTeachDis(false);
        setdataRegStatus(false);
        setOtpModal(true);
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (e) {
      setdataRegStatus(false);
      console.log(e, "error");
    }
  };

  const RegresendOTPfunc = (type) => {
    if(type && type === "Student"){
      generateOTPfunc("registration", "Stu", "Student");
    }
    if(type && type === "Parent"){
      generateOTPfunc("registration", "Par", "Parent");
    }
    if(type && type === "Teacher"){
      generateOTPfunc("registration", "Tec", "Teacher");
    }
  }
  //abhinaya
  const studentregisterfunc = () => {
    setRegisterModal(false);
    setStudentRegisterModal(true);
    generateOTPfunc("registration", "Stu", "Student");
  };
  const parentregisterfunc = () => {
    setRegisterModal(false);
    setParentRegisterModal(true);
    generateOTPfunc("registration", "Par", "Parent");
  };
  const teacherregisterfunc = () => {
    setRegisterModal(false);
    setTeacherregisterModal(true);
    generateOTPfunc("registration", "Tec", "Teacher");
  };
  const adminregisterfunc = () => {
    setRegisterModal(false);
    setAdminregisterModal(true);
    generateOTPfunc("registration", "Tec", "Teacher");
  };
  const registerAndVerify = async (regtype) => {
    try {
      switch (regtype) {
        case "student-registration":
          await addStudent();
          break;
        case "teacher-registration":
          await addTeacher();
          break;
        case "parent-registration":
          await addParent();
          break;
        default:
          console.error("Invalid registration type");
      }
      // setOtpModal(true);
    } catch (error) {
      console.error("Error during registration:", error);
    }
  };
  const pwdResetfunc = async () => {
    try {
      const isMobileTrue = /^\d+$/.test(LoginState.user);
      let bod = {
        userId: selecteduserId ? selecteduserId : (roleName === "Student" ? (isMobileTrue ? LoginState.user : `S${LoginState.user}`) : roleName === "Teacher" ? (isMobileTrue ? LoginState.user : `T${LoginState.user}`) : LoginState.user),
        password: enterPwd.pwd,
        role: roleName,
      };

      let res = await forgetpwd(bod);

      if (res?.success === true) {
        toast.success(res?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setPwdModal(false);
        setEnterPwd("");
        setroleName("");
        setselecteduserId("");
        setUserValidate(false);
        setUserValidateList({});
        setLoginState({ ...LoginState, user: "" });
        setEnterPwd({ ...enterPwd, pwd: "", confirmPwd: "" });
      } else {
        console.log(res.error, res, "testtstst");
        toast.error(res?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [selectedSubjectsTeach, setSelectedSubjectsTeach] = useState([]);
  const [showAllSubjectsTeach, setShowAllSubjectsTeach] = useState(false);
  const handleCheckboxChangeTeach = (id) => {
    const updatedSelectedSubjects = { ...selectedSubjectsTeach };
    console.log(updatedSelectedSubjects, "updatedSelectedSubjects");
    if (!updatedSelectedSubjects[id] === false) {
      delete updatedSelectedSubjects[id];
    } else {
      updatedSelectedSubjects[id] = !updatedSelectedSubjects[id];
    }
    setSelectedSubjectsTeach(updatedSelectedSubjects);
    console.log(Object.keys(selectedSubjectsTeach), "updatedSelectedSubjects");
  };

  const handleSelectAllTeach = () => {
    const allSelected = Object.values(subteacherarray)
      .flat()
      .reduce((acc, x) => {
        acc[x._id] = true;
        return acc;
      }, {});
    setSelectedSubjectsTeach(allSelected);
  };

  const handleClearAllTeach = () => {
    setSelectedSubjectsTeach([]);
  };

  const handlePhoneNumberChange = (e, stateSetter) => {
    const input = e.target.value;
    console.log(input?.length,"handlePhoneNumberChange");
    console.log(input?.length,"handlePhoneNumberChange");
    console.log(selectedCountry?.maxLength,"handlePhoneNumberChange");
    if(input !== "" && regexNumber.test(input)){
      if(input?.length <= selectedCountry?.maxLength){
        stateSetter((prevState) => ({ ...prevState, number: input }));
      }
    } else {
        stateSetter((prevState) => ({ ...prevState, number: "" }));
    }
    // const numberRegex = /^\d{0,10}$/;

    // if (numberRegex.test(input)) {
    //   stateSetter((prevState) => ({ ...prevState, number: input }));
    // }
  };
  const handleSuggestionClick = (name) => {
    console.log(name, "testnamesss");
    setState({
      ...state,
      user: `${name}`,
      // suggestion: false,
      suggestionCard: false,
    });
    setSelectedSuggestion(name);
  };
  const handleSuggestionClickteach = (name) => {
    console.log(name, "testnamesss");
    setStateTeacher({
      ...stateTeacher,
      user: `${name}`,
      // suggestion: false,
      suggestionCard: false,
    });
    setSelectedSuggestionteach(name);
  };
  const handleSuggestionClickparent = (name) => {
    console.log(name, "testnamesss");
    setparentState({
      ...parentState,
      user: name,
      // suggestion: false,
      suggestionCard: false,
    });
    setSelectedSuggestionparent(name);
  };

  const handleButtonClickTeach = () => {
    setShowAllSubjectsTeach(!showAllSubjectsTeach);
  };

  const addKatbookFunc = async () => {
    setTeacherAddbookModal(true);
    let Mediumdata = UserProfileData.medium.map((medium) => ({
      label: medium.variableName,
      value: medium._id,
    }));

    // console.log(UserProfileData.standard,"STDDDDD");
    // console.log(Mediumdata,"STDDDDD");

    let Standarddata = UserProfileData.standard.map((standard) => ({
      label:
        standard.variableName +
        " Std - " +
        UserProfileData.medium.filter(
          (cc) => cc._id === standard.parentVaribaleId
        )[0].variableName +
        "",
      value: standard._id,
    }));

    let Subjectdata = UserProfileData.subjects.map((subss) => ({
      label: subss.parentVaribaleId.variableName,
      value: subss.parentVaribaleId._id,
    }));

    const allSelected = UserProfileData.subjects.flat().reduce((acc, x) => {
      acc[x.parentVaribaleId._id] = true;
      return acc;
    }, {});
    setSelectedSubjectsTeach(allSelected);
    setSelectedSubjects(allSelected);
    console.log(allSelected, "STDDDDD");

    var medium_data = UserProfileData.medium.map((item) => {
      return item._id;
    });

    let medbod = {
      variableIds: medium_data,
    };
    let Medres = await getstandardbyMID(medbod);

    if (Medres?.success === true) {
      const allowedClasses = ["Class 1", "Class 6", "Class 12"];
      console.log(Medres, "aftersuccess");
      let data = Medres.data
        .filter((std) => allowedClasses.includes(std.variableName))
        .sort(
          (a, b) =>
            allowedClasses.indexOf(a.variableName) -
            allowedClasses.indexOf(b.variableName)
        )
        .map((std) => ({
          label: std.variableName + " Std - " + std.class + "",
          value: std._id,
        }));
      console.log(data, "wwwwwwwwwwwwwwwwww");
      setstdteacherarray(data);

      const Stdvalue = Standarddata.map((standard) => standard.value);
      let bod = {
        variableIds: Stdvalue,
      };
      let res = await getstandardbyMID(bod, "teacher");
      if (res?.success === true) {
        console.log(res.data, "subjectdaaaaa");
        setsubteacherarray(res.data);
      } else {
        setsubteacherarray([]);
      }
    }

    setStateTeacher({
      ...stateTeacher,
      MediumInstruction: Mediumdata,
      Standard: Standarddata,
    });
    setTeacherAddbookModal(true);
  };
  useEffect(() => {
    if (addbookOpen) {
      emptyState();
      const StudentUserData = async (type) => {
        if (type === "Student") {
          let Mediumdata = UserProfileData.medium.map((medium) => ({
            label: medium.variableName,
            value: medium._id,
          }));

          // console.log(UserProfileData.standard,"STDDDDD");
          // console.log(Mediumdata,"STDDDDD");

          let Standarddata = UserProfileData.standard.map((standard) => ({
            label:
              standard.variableName +
              " Std - " +
              UserProfileData.medium.filter(
                (cc) => cc._id === standard.parentVaribaleId
              )[0].variableName +
              "",
            value: standard._id,
          }));

          let Subjectdata = UserProfileData.subjects.map((subss) => ({
            label: subss.parentVaribaleId.variableName,
            value: subss.parentVaribaleId._id,
          }));

          const allSelected = UserProfileData.subjects
            .flat()
            .reduce((acc, x) => {
              acc[x.parentVaribaleId._id] = true;
              return acc;
            }, {});
          setSelectedSubjectsTeach(allSelected);
          setSelectedSubjects(allSelected);
          console.log(allSelected, "STDDDDD");

          var medium_data = UserProfileData.medium.map((item) => {
            return item._id;
          });

          let medbod = {
            variableIds: medium_data,
          };
          let Medres = await getstandardbyMID(medbod);

          if (Medres?.success === true) {
            const allowedClasses = ["Class 1", "Class 6", "Class 12"];
            console.log(Medres, "aftersuccess");
            let data = Medres.data
              .filter((std) => allowedClasses.includes(std.variableName))
              .sort(
                (a, b) =>
                  allowedClasses.indexOf(a.variableName) -
                  allowedClasses.indexOf(b.variableName)
              )
              .map((std) => ({
                label: std.variableName + " Std - " + std.class + "",
                value: std._id,
              }));
            console.log(data, "wwwwwwwwwwwwwwwwww");
            setstdteacherarray(data);

            const Stdvalue = Standarddata.map((standard) => standard.value);
            let bod = {
              variableIds: Stdvalue,
            };
            let res = await getstandardbyMID(bod, "teacher");
            if (res?.success === true) {
              console.log(res.data, "subjectdaaaaa");
              setsubteacherarray(res.data);
            } else {
              setsubteacherarray([]);
            }
          }

          setStateTeacher({
            ...stateTeacher,
            MediumInstruction: Mediumdata,
            Standard: Standarddata,
          });
          setTeacherAddbookModal(true);
        }
        if (type === "Teacher") {
          let Mediumdata = UserProfileData.medium.map((medium) => ({
            label: medium.variableName,
            value: medium._id,
          }));

          // console.log(UserProfileData.standard,"STDDDDD");
          // console.log(Mediumdata,"STDDDDD");

          let Standarddata = UserProfileData.standard.map((standard) => ({
            label:
              standard.variableName +
              " Std - " +
              UserProfileData.medium.filter(
                (cc) => cc._id === standard.parentVaribaleId
              )[0].variableName +
              "",
            value: standard._id,
          }));

          let Subjectdata = UserProfileData.subjects.map((subss) => ({
            label: subss.parentVaribaleId.variableName,
            value: subss.parentVaribaleId._id,
          }));

          const allSelected = UserProfileData.subjects
            .flat()
            .reduce((acc, x) => {
              acc[x.parentVaribaleId._id] = true;
              return acc;
            }, {});
          setSelectedSubjectsTeach(allSelected);
          setSelectedSubjects(allSelected);
          console.log(allSelected, "STDDDDD");

          var medium_data = UserProfileData.medium.map((item) => {
            return item._id;
          });

          let medbod = {
            variableIds: medium_data,
          };
          let Medres = await getstandardbyMID(medbod);

          if (Medres?.success === true) {
            const allowedClasses = ["Class 1", "Class 6", "Class 12"];
            console.log(Medres, "aftersuccess");
            let data = Medres.data
              .filter((std) => allowedClasses.includes(std.variableName))
              .sort(
                (a, b) =>
                  allowedClasses.indexOf(a.variableName) -
                  allowedClasses.indexOf(b.variableName)
              )
              .map((std) => ({
                label: std.variableName + " Std - " + std.class + "",
                value: std._id,
              }));
            console.log(data, "wwwwwwwwwwwwwwwwww");
            setstdteacherarray(data);

            const Stdvalue = Standarddata.map((standard) => standard.value);
            let bod = {
              variableIds: Stdvalue,
            };
            let res = await getstandardbyMID(bod, "teacher");
            if (res?.success === true) {
              console.log(res.data, "subjectdaaaaa");
              setsubteacherarray(res.data);
            } else {
              setsubteacherarray([]);
            }
          }

          setStateTeacher({
            ...stateTeacher,
            MediumInstruction: Mediumdata,
            Standard: Standarddata,
          });
          setTeacherAddbookModal(true);
        }
        if (type === "Admin") {
          let Mediumdata = UserProfileData.medium.map((medium) => ({
            label: medium.variableName,
            value: medium._id,
          }));

          // console.log(UserProfileData.standard,"STDDDDD");
          // console.log(Mediumdata,"STDDDDD");

          let Standarddata = UserProfileData.standard.map((standard) => ({
            label:
              standard.variableName +
              " Std - " +
              UserProfileData.medium.filter(
                (cc) => cc._id === standard.parentVaribaleId
              )[0].variableName +
              "",
            value: standard._id,
          }));

          let Subjectdata = UserProfileData.subjects.map((subss) => ({
            label: subss.parentVaribaleId.variableName,
            value: subss.parentVaribaleId._id,
          }));

          const allSelected = UserProfileData.subjects
            .flat()
            .reduce((acc, x) => {
              acc[x.parentVaribaleId._id] = true;
              return acc;
            }, {});
          setSelectedSubjectsTeach(allSelected);
          setSelectedSubjects(allSelected);
          console.log(allSelected, "STDDDDD");

          var medium_data = UserProfileData.medium.map((item) => {
            return item._id;
          });

          let medbod = {
            variableIds: medium_data,
          };
          let Medres = await getstandardbyMID(medbod);

          if (Medres?.success === true) {
            const allowedClasses = ["Class 1", "Class 6", "Class 12"];
            console.log(Medres, "aftersuccess");
            let data = Medres.data
              .filter((std) => allowedClasses.includes(std.variableName))
              .sort(
                (a, b) =>
                  allowedClasses.indexOf(a.variableName) -
                  allowedClasses.indexOf(b.variableName)
              )
              .map((std) => ({
                label: std.variableName + " Std - " + std.class + "",
                value: std._id,
              }));
            console.log(data, "wwwwwwwwwwwwwwwwww");
            setstdteacherarray(data);

            const Stdvalue = Standarddata.map((standard) => standard.value);
            let bod = {
              variableIds: Stdvalue,
            };
            let res = await getstandardbyMID(bod, "teacher");
            if (res?.success === true) {
              console.log(res.data, "subjectdaaaaa");
              setsubteacherarray(res.data);
            } else {
              setsubteacherarray([]);
            }
          }

          setStateTeacher({
            ...stateTeacher,
            MediumInstruction: Mediumdata,
            Standard: Standarddata,
          });
          setTeacherAddbookModal(true);
        }

        if (UserProfileType?.usertype === "Student") {
          setTeacherAddbookModal(true);
        } else if (
          UserProfileType?.usertype === "Teacher" ||
          UserProfileType?.usertype === "Admin"
        ) {
          setTeacherAddbookModal(true);
        }
        setaddbookOpen(false);
      };

      if (UserProfileType) {
        StudentUserData(UserProfileType?.usertype);
      }
    }
  }, [addbookOpen]);

  useEffect(() => {
    var lastScrollTop;
    let navbar = document.getElementById("navbar");

    const handleScroll = () => {
      if (navbar) {
        var scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > lastScrollTop) {
          navbar.style.top = "-80px";
        } else {
          navbar.style.top = "0px";
        }
        lastScrollTop = scrollTop;
      }
    };

    // Check screen width before adding the scroll event listener
    const addScrollListener = () => {
      if (window.innerWidth > 600) {
        window.addEventListener("scroll", handleScroll);
      }
    };

    addScrollListener(); // Add the listener initially

    // Cleanup: Remove the scroll event listener when component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isNumber = (value) => {
    console.log(value, "yyyyyyyyyyy");
    if (typeof value === "string") {
      console.log(!isNaN(value), "yyyyyyyyyyy");
      return !isNaN(value);
    }
  };

  const uservalidateFunc = async (mobileNo) => {
    let bod = {
      mobileNo: mobileNo,
      role: roleName,
    };

    let res = await getUserListFromUsers(bod);

    if (res.success) {
      if (res?.data?.otherUser?.length > 1) {
        setUserValidate(true);
        setUserValidateList(res.data);
      } else {
        setUserValidate(false);
        setUserValidateList({});
      }
    } else {
      setUserValidate(false);
      setUserValidateList({});
      toast.error(res?.error);
    }
  };

  useEffect(() => {
    const username = localStorage.getItem("username");
    setUserName(username);
    const encryptedStandard = localStorage.getItem("encryptedStandard");
    if (
      encryptedStandard !== null &&
      encryptedStandard !== undefined &&
      encryptedStandard !== ""
    ) {
      const decryptedStandard = CryptoJS.AES.decrypt(
        encryptedStandard,
        secretKey
      );
      const standard = JSON.parse(
        decryptedStandard.toString(CryptoJS.enc.Utf8)
      );
    } else {
      // const currentVersion = localStorage.getItem("app_version");
      localStorage.removeItem("userID");
      localStorage.removeItem("userCode");
      localStorage.removeItem("username");
      localStorage.removeItem("encryptedMedium");
      localStorage.removeItem("encryptedSubjects");
      localStorage.removeItem("encryptedStandard");
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      localStorage.removeItem("IsUserAuth");
      localStorage.removeItem("userType");
      localStorage.removeItem("username");
      // localStorage.clear();
      // localStorage.setItem("app_version", currentVersion);
      navigate("/");
    }
  }, []);

  return (
    <Fragment>
      {!userAuth && (
        <div className="">
          <div className="">
            <div id="navbar" className="backGroung_sky fixed w-100">
              <MediaQuery minWidth={700}>
                <div className="py-3 headapp3">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center headempup">
                      {/* <div className="frstLogo"> */}
                      <img
                        src={headerEmbelem}
                        className="headEmbelemwid"
                        onClick={() => {
                          navigate("/");
                        }}
                      />
                      <div className="haeddrop">
                        <div className="headrop1">
                          <select
                            value={selectedLang}
                            onChange={(e) => setSelectedLang(e.target.value)}
                            className="haedrop3"
                          >
                            {languages.map((lang) => (
                              <option
                                key={lang.code}
                                value={lang.code}
                                className="headrop4"
                              >
                                {lang.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="d-flex align-items-center search-fieldS">
                        {/* <MdOutlineSearch className="search-icon" />
                        <input
                          type="text"
                          placeholder="Search"
                          className="search-input"
                        />
                        <MdOutlineMic className="mic-icon" /> */}
                      </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-4 padperfitenn">
                      <Link
                        to="/"
                        className={`header_content_font textDecvor ${
                          activeTab === "Home" ? "glass-btn" : ""
                        }`}
                        onClick={() => handleTabClick("Home")}
                      >
                        {lang === "en" ? "Home" : lang === "hi" ? "होम" : null}
                      </Link>
                      <Link
                        to="/katbook"
                        className={`header_content_font textDecvor ${
                          activeTab === "KATBOOK" ? "glass-btn" : ""
                        }`}
                        onClick={() => handleTabClick("KATBOOK")}
                      >
                        {lang === "en"
                          ? "KATBOOK"
                          : lang === "hi"
                          ? "कैटबुक"
                          : null}
                      </Link>
                      <Link
                        to="/ueducate"
                        className={`header_content_font textDecvor ${
                          activeTab === "UEducate" ? "glass-btn" : ""
                        }`}
                        onClick={() => handleTabClick("UEducate")}
                      >
                        {lang === "en"
                          ? "UEducate"
                          : lang === "hi"
                          ? "यूएजुकेट"
                          : null}
                      </Link>
                      {localStorage.getItem("token") === null ||
                      localStorage.getItem("token") === undefined ||
                      localStorage.getItem("token") === "" ? (
                        <Link
                          to="/feedback"
                          className={`header_content_font textDecvor ${
                            activeTab === "Evaluation" ? "glass-btn" : ""
                          }`}
                          onClick={() => handleTabClick("Evaluation")}
                        >
                          {lang === "en"
                            ? "Feedback"
                            : lang === "hi"
                            ? "प्रतिपुष्टि"
                            : null}
                        </Link>
                      ) : (
                        <Link
                          to="/bookview"
                          className={`header_content_font textDecvor ${
                            activeTab === "MyKatbook" ? "glass-btn" : ""
                          }`}
                          onClick={() => handleTabClick("MyKatbook")}
                        >
                          {lang === "en"
                            ? "My Katbook"
                            : lang === "hi"
                            ? "मेरी कैटबुक"
                            : null}
                        </Link>
                      )}
                    </div>

                    {localStorage.getItem("token") === null ||
                    localStorage.getItem("token") === undefined ||
                    localStorage.getItem("token") === "" ? (
                      <div className="d-flex align-items-center gap-4">
                        <div
                          className={`header_content_font ${
                            activeTab === "Login" ? "fw-bold" : ""
                          }`}
                          onClick={() => {
                            setLoginRoleModal(true);
                          }}
                        >
                          <BiLogInCircle size={"22"} />{" "}
                          {lang === "en"
                            ? "Login "
                            : lang === "hi"
                            ? "लॉगिन"
                            : null}
                        </div>
                        <div
                          className="header_content_font_register px-3 py-2"
                          onClick={() => {
                            setRegisterModal(!registerModal);
                          }}
                        >
                          {lang === "en"
                            ? "Register"
                            : lang === "hi"
                            ? "पंजीकरण"
                            : null}
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center"
                        onClick={handleclick}
                      >
                        <div>
                          <img
                            src="https://cdn.katbook.com/assets/sites/ncert/754664531585798144_ProfileLogo.png"
                            alt="profile"
                          />
                        </div>
                        <div className="d-flex flex-column align-items-start justify-content-center mx-2">
                          <div className="text-login-website capiterm">
                            {localStorage.getItem("username")}
                          </div>
                          <div className="section-website-login">
                            {UserProfileData?.userTypeId?.usertype === "Teacher"
                              ? "Teacher"
                              : UserProfileData?.userTypeId?.usertype ===
                                "Parent"
                              ? "PARENT"
                              : UserProfileData?.userTypeId?.usertype ===
                                "Admin"
                              ? "Admin"
                              : UserProfileData?.userTypeId?.usertype ===
                                "Student"
                              ? "Student"
                              : null}{" "}
                          </div>
                        </div>
                        {/* {!loginProfiles ? ( */}
                        <div className="pt-0 cursor">
                          <FaChevronDown size={12} color="#fff" />
                        </div>
                        {/* // ) : (
                        // <div className="pt-0 cursor xidthwbook">
                        // </div>
                        // )} */}
                      </div>
                    )}
                  </div>
                  {/* </div>
                  </div> */}
                </div>

                {loginProfiles && (
                  <div ref={dropdownRef}>
                    <div className="d-flex flex-column gap-2 backgroundeffectwebsite">
                      <div className="iconshowCard">
                        <MdArrowDropUp color="#fff" size={30} />
                      </div>
                      {/* <div className="sections  px-3 py-1">
                      <VscFeedback size={20} />
                      &nbsp; Feedback
                    </div>
                    <div className="sections  px-3 py-1">
                      <IoMdAnalytics size={20} />
                      &nbsp; Coverage Report
                    </div>
                    <div className="sections  px-3 py-1" onClick={()=>{
                      addKatbookFunc()
                    }}>
                      <FaBookMedical size={20} />
                      &nbsp; Add Katbook
                    </div> */}
                      {/* <div className='key px-3 py-1'><RiPushpinFill size={20} />&nbsp; @122334</div> */}
                      <div className="sections px-3 py-1 capiterm">
                        {/* <FaUnlock size={20} />
                        &nbsp; Change Password */}
                        <CgProfile size={20} />
                        &nbsp; {localStorage.getItem("username")}
                      </div>
                      <div
                        className="sections px-3 py-1"
                        onClick={handleLogoutView}
                      >
                        <MdOutlineLogout size={20} />
                        &nbsp; Log Out
                      </div>
                    </div>
                  </div>
                )}
              </MediaQuery>
              <MediaQuery maxWidth={700}>
                <div class="container py-3 d-flex align-items-center justify-content-between w-100">
                  {/* <div>
                  <img
                    src="https://cdn.katbook.com/assets/sites/ncert/754664531556438016_emblem.png"
                    className="headerEmbelem"
                  />
                </div> */}

                  {/* <div
                    style={{ width: "50%" }}
                    className="d-flex align-items-center gap-4"
                  >
                    <div
                      style={{ width: "fit-content" }}
                      onClick={() => {
                        navigate("/");
                      }}
                    >
                      <img
                        src="https://cdn.katbook.com/assets/sites/ncert/754664531418025984_HeaderEmbelem.png"
                        style={{ width: "100%" }}
                      />
                    </div>

                    <div>
                      <img
                        src="https://cdn.katbook.com/assets/sites/ncert/754664531556438016_NCERT300px.png"
                        style={{ width: "50%" }}
                      />
                    </div>
                  </div> */}

                  <div className="d-flex justify-content-between align-items-center w-100">
                    {/* <div className="frstLogo"> */}

                    <div className="relative headempup">
                      {menuOpen ? (
                        <div
                          onClick={() => {
                            setMenuOpen(false);
                            setMenuOpenContent(false);
                          }}
                        >
                          <IoMdClose color="#fff" size={25} />
                        </div>
                      ) : (
                        <div>
                          <GiHamburgerMenu
                            color="#fff"
                            size={25}
                            onClick={() => {
                              setMenuOpen(true);
                              setMenuOpenContent(true);
                            }}
                          />
                        </div>
                      )}

                      {menuOpenContent && (
                        <div className="absolute">
                          <div className="contact-dropdown-width_writeMail">
                            <div className="d-flex flex-column">
                              <Link
                                to="/"
                                className={`textDecvor border-bottom py-2 px-3 ${
                                  activeTab === "Home"
                                    ? "dropdown-name-font-head"
                                    : "dropdown-name-font"
                                }`}
                                onClick={() => {
                                  setMenuOpen(false);
                                  setMenuOpenContent(false);
                                }}
                              >
                                {lang === "en"
                                  ? "Home"
                                  : lang === "hi"
                                  ? "होम"
                                  : null}
                              </Link>
                              <Link
                                to="/katbook"
                                className={`textDecvor border-bottom py-2 px-3 ${
                                  activeTab === "KATBOOK"
                                    ? "dropdown-name-font-head"
                                    : "dropdown-name-font"
                                }`}
                                onClick={() => {
                                  setMenuOpen(false);
                                  setMenuOpenContent(false);
                                }}
                              >
                                {lang === "en"
                                  ? "KATBOOK"
                                  : lang === "hi"
                                  ? "कैटबुक"
                                  : null}
                              </Link>
                              <Link
                                to="/ueducate"
                                className={`textDecvor border-bottom py-2 px-3 ${
                                  activeTab === "UEducate"
                                    ? "dropdown-name-font-head"
                                    : "dropdown-name-font"
                                }`}
                                onClick={() => {
                                  setMenuOpen(false);
                                  setMenuOpenContent(false);
                                }}
                              >
                                {lang === "en"
                                  ? "U-Educate"
                                  : lang === "hi"
                                  ? "यूएजुकेट"
                                  : null}
                              </Link>

                              {localStorage.getItem("token") === null ||
                              localStorage.getItem("token") === undefined ||
                              localStorage.getItem("token") === "" ? (
                                <Link
                                  to="/feedback"
                                  className={`textDecvor border-bottom py-2 px-3 ${
                                    activeTab === "Evaluation"
                                      ? "dropdown-name-font-head"
                                      : "dropdown-name-font"
                                  }`}
                                  onClick={() => {
                                    setMenuOpen(false);
                                    setMenuOpenContent(false);
                                  }}
                                >
                                  {lang === "en"
                                    ? "Feedback"
                                    : lang === "hi"
                                    ? "प्रतिपुष्टि"
                                    : null}
                                </Link>
                              ) : (
                                <Link
                                  to="/bookview"
                                  className={`textDecvor border-bottom py-2 px-3 ${
                                    activeTab === "MyKatbook"
                                      ? "dropdown-name-font-head"
                                      : "dropdown-name-font"
                                  }`}
                                  onClick={() => {
                                    setMenuOpen(false);
                                    setMenuOpenContent(false);
                                  }}
                                >
                                  {lang === "en"
                                    ? "My Katbook"
                                    : lang === "hi"
                                    ? "मेरी कैटबुक"
                                    : null}
                                </Link>
                              )}

                              {localStorage.getItem("token") === null ||
                              localStorage.getItem("token") === undefined ||
                              localStorage.getItem("token") === "" ? (
                                <>
                                  <div
                                    // className={`header_content_font ${activeTab === "Login" ? "fw-bold" : ""}`}
                                    className={`textDecvor border-bottom py-2 px-3 ${
                                      activeTab === "Login"
                                        ? "dropdown-name-font-head"
                                        : "dropdown-name-font"
                                    }`}
                                    onClick={() => {
                                      setLoginRoleModal(true);
                                      setMenuOpen(false);
                                      setMenuOpenContent(false);
                                    }}
                                  >
                                    <BiLogInCircle size={"22"} />{" "}
                                    {lang === "en"
                                      ? "Login "
                                      : lang === "hi"
                                      ? "लॉगिन"
                                      : null}
                                  </div>

                                  <div
                                    // className="header_content_font_register px-3 py-2"
                                    className={`textDecvor border-bottom py-2 px-3 ${
                                      activeTab === "Register"
                                        ? "dropdown-name-font-head"
                                        : "dropdown-name-font"
                                    }`}
                                    onClick={() => {
                                      setRegisterModal(!registerModal);
                                      setMenuOpen(false);
                                      setMenuOpenContent(false);
                                    }}
                                  >
                                    {lang === "en"
                                      ? "Register"
                                      : lang === "hi"
                                      ? "पंजीकरण"
                                      : null}
                                  </div>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <>
                      <img
                        src={headerEmbelem}
                        className="headEmbelemwid"
                        onClick={() => {
                          navigate("/");
                        }}
                      />
                      <div className="haeddrop">
                        <div className="headrop1">
                          <select
                            value={selectedLang}
                            onChange={(e) => setSelectedLang(e.target.value)}
                            className="haedrop3"
                          >
                            {languages.map((lang) => (
                              <option
                                key={lang.code}
                                value={lang.code}
                                className="headrop4"
                              >
                                {lang.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </>

                    <div className="relative headempup">
                      {localStorage.getItem("token") === null ||
                      localStorage.getItem("token") === undefined ||
                      localStorage.getItem("token") === "" ? null : (
                        <div>
                          <CgProfile
                            color="#fff"
                            size={30}
                            onClick={() => {
                              setMenuOpenContent1(!menuOpenContent1);
                            }}
                          />
                        </div>
                      )}

                      {menuOpenContent1 && (
                        <div className="absolute_profile">
                          <div className="contact-dropdown-width_writeMail">
                            <div className="d-flex flex-column">
                              {localStorage.getItem("token") === null ||
                              localStorage.getItem("token") === undefined ||
                              localStorage.getItem("token") === "" ? null : (
                                <>
                                  <div className="d-flex align-items-center gap-2 textDecvor border-bottom py-2 px-3">
                                    <div>
                                      <CgProfile size={20} />
                                    </div>

                                    <div className="d-flex flex-column">
                                      <div className="text-login-black capiterm">
                                        {localStorage.getItem("username")}
                                      </div>
                                      <div className="text-login-black-type">
                                        {UserProfileData?.userTypeId
                                          ?.usertype === "Teacher"
                                          ? "Teacher"
                                          : UserProfileData?.userTypeId
                                              ?.usertype === "Parent"
                                          ? "PARENT"
                                          : UserProfileData?.userTypeId
                                              ?.usertype === "Admin"
                                          ? "Admin"
                                          : UserProfileData?.userTypeId
                                              ?.usertype === "Student"
                                          ? "Student"
                                          : null}
                                      </div>
                                    </div>
                                  </div>

                                  <div>
                                    <Link
                                      to="/bookview"
                                      className="d-flex align-items-center gap-2 textDecvor border-bottom py-2 px-3 sections_pass"
                                      onClick={() => setMenuOpenContent1(false)}
                                    >
                                      <div>
                                        <TbBook2 size={18} />
                                      </div>
                                      <div>
                                        {lang === "en"
                                          ? "My Katbook"
                                          : lang === "hi"
                                          ? "मेरी कैटबुक"
                                          : null}
                                      </div>
                                    </Link>
                                  </div>

                                  {/* <div className="d-flex align-items-center gap-2 sections_pass textDecvor border-bottom py-2 px-3">
                                    <div>
                                      <GoUnlock size={18} />
                                    </div>
                                    <div>Change Password</div>
                                  </div> */}
                                  <div
                                    className="d-flex align-items-center gap-2 sections_pass textDecvor border-bottom py-2 px-3"
                                    onClick={handleLogoutView}
                                  >
                                    <div>
                                      <MdOutlineLogout size={18} />
                                    </div>
                                    <div>Log Out</div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* <div className="d-flex align-items-center search-fieldS">
                      <MdOutlineSearch className="search-icon" />
                      <input
                        type="text"
                        placeholder="Search"
                        className="search-input"
                      />
                      <MdOutlineMic className="mic-icon" />
                    </div> */}

                    {/* <div className="relative">
                      {menuOpen ? (
                        <div
                          onClick={() => {
                            setMenuOpen(false);
                            setMenuOpenContent(false);
                          }}
                        >
                          <IoMdClose color="#fff" size={25} />
                        </div>
                      ) : (
                        <div>
                          <GiHamburgerMenu
                            color="#fff"
                            size={25}
                            onClick={() => {
                              setMenuOpen(true);
                              setMenuOpenContent(true);
                            }}
                          />
                        </div>
                      )}

                      {menuOpenContent && (
                        <div className="absolute">
                          <div className="contact-dropdown-width_writeMail">
                            <div className="d-flex flex-column">
                              <Link
                                to="/"
                                className={`textDecvor border-bottom py-2 px-3 ${activeTab === "Home"
                                  ? "dropdown-name-font-head"
                                  : "dropdown-name-font"
                                  }`}
                                onClick={() => {
                                  setMenuOpen(false);
                                  setMenuOpenContent(false);
                                }}
                              >
                                {lang === "en"
                                  ? "Home"
                                  : lang === "hi"
                                    ? "होम"
                                    : null}
                              </Link>
                              <Link
                                to="/katbook"
                                className={`textDecvor border-bottom py-2 px-3 ${activeTab === "KATBOOK"
                                  ? "dropdown-name-font-head"
                                  : "dropdown-name-font"
                                  }`}
                                onClick={() => {
                                  setMenuOpen(false);
                                  setMenuOpenContent(false);
                                }}
                              >
                                {lang === "en"
                                  ? "KATBOOK"
                                  : lang === "hi"
                                    ? "कैटबुक"
                                    : null}
                              </Link>
                              <Link
                                to="/ueducate"
                                className={`textDecvor border-bottom py-2 px-3 ${activeTab === "UEducate"
                                  ? "dropdown-name-font-head"
                                  : "dropdown-name-font"
                                  }`}
                                onClick={() => {
                                  setMenuOpen(false);
                                  setMenuOpenContent(false);
                                }}
                              >
                                {lang === "en"
                                  ? "U-Educate"
                                  : lang === "hi"
                                    ? "यूएजुकेट"
                                    : null}
                              </Link>
                              {localStorage.getItem("token") === null ||
                                localStorage.getItem("token") === undefined ||
                                localStorage.getItem("token") === "" ? (
                                <Link
                                  to="/feedback"
                                  className={`textDecvor border-bottom py-2 px-3 ${activeTab === "Evaluation"
                                    ? "dropdown-name-font-head"
                                    : "dropdown-name-font"
                                    }`}
                                  onClick={() => {
                                    setMenuOpen(false);
                                    setMenuOpenContent(false);
                                  }}
                                >
                                  {lang === "en"
                                    ? "Feedback"
                                    : lang === "hi"
                                      ? "प्रतिपुष्टि"
                                      : null}
                                </Link>
                              ) : (
                                <Link
                                  to="/bookview"
                                  className={`textDecvor border-bottom py-2 px-3 ${activeTab === "MyKatbook"
                                    ? "dropdown-name-font-head"
                                    : "dropdown-name-font"
                                    }`}
                                  onClick={() => {
                                    setMenuOpen(false);
                                    setMenuOpenContent(false);
                                  }}
                                >
                                  {lang === "en"
                                    ? "My Katbook"
                                    : lang === "hi"
                                      ? "मेरी कैटबुक"
                                      : null}
                                </Link>
                              )}


                              {localStorage.getItem("token") === null ||
                                localStorage.getItem("token") === undefined ||
                                localStorage.getItem("token") === "" ? (
                                <>
                                  <div
                                    // className={`header_content_font ${activeTab === "Login" ? "fw-bold" : ""}`}
                                    className={`textDecvor border-bottom py-2 px-3 ${activeTab === "Login"
                                      ? "dropdown-name-font-head"
                                      : "dropdown-name-font"
                                      }`}
                                    onClick={() => {
                                      setLoginRoleModal(true);
                                      setMenuOpen(false);
                                      setMenuOpenContent(false);
                                    }}
                                  >
                                    <BiLogInCircle size={"22"} />{" "}
                                    {lang === "en"
                                      ? "Login "
                                      : lang === "hi"
                                        ? "लॉगिन"
                                        : null}
                                  </div>

                                  <div
                                    // className="header_content_font_register px-3 py-2"
                                    className={`textDecvor border-bottom py-2 px-3 ${activeTab === "Register"
                                      ? "dropdown-name-font-head"
                                      : "dropdown-name-font"
                                      }`}
                                    onClick={() => {
                                      setRegisterModal(!registerModal);
                                      setMenuOpen(false);
                                      setMenuOpenContent(false);
                                    }}
                                  >
                                    {lang === "en"
                                      ? "Register"
                                      : lang === "hi"
                                        ? "पंजीकरण"
                                        : null}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="d-flex align-items-center gap-2 textDecvor border-bottom py-2 px-3"
                                  // onClick={() => {
                                  //   setRegisterModal(!registerModal);
                                  //   setMenuOpen(false);
                                  //   setMenuOpenContent(false);
                                  // }}
                                  >
                                    <div>
                                      <CgProfile size={30} />
                                    </div>

                                    <div className="d-flex flex-column">
                                      <div className="text-login-black">
                                        {localStorage.getItem("username")}
                                      </div>
                                      <div className="text-login-black-type">
                                        {UserProfileData?.userTypeId?.usertype === "Teacher"
                                          ? "Teacher"
                                          : UserProfileData?.userTypeId?.usertype ===
                                            "Parent"
                                            ? "PARENT"
                                            : UserProfileData?.userTypeId?.usertype ===
                                              "Admin"
                                              ? "Admin"
                                              : UserProfileData?.userTypeId?.usertype ===
                                                "Student"
                                                ? "Student"
                                                : null}
                                      </div>

                                    </div>
                                  </div>

                                  <div className="d-flex align-items-center gap-2 sections_pass textDecvor border-bottom py-2 px-3">
                                    <div>
                                      <FaUnlock size={18} />
                                    </div>
                                    <div>
                                      Change Password
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center gap-2 sections_pass textDecvor border-bottom py-2 px-3" onClick={handleLogout}>
                                    <div>
                                      <MdOutlineLogout size={18} />
                                    </div>
                                    <div>
                                      Log Out
                                    </div>
                                  </div>
                                </>
                              )}





                            </div>
                          </div>
                        </div>
                      )}
                    </div> */}
                  </div>

                  {/* <div className="col-md-8">
                    <div className="d-flex align-items-center justify-content-end gap-5">
                      <Link
                        to="/"
                        className={`header_content_font textDecvor ${
                          activeTab === "Home" ? "fw-bold glass-btn" : ""
                        }`}
                        onClick={() => handleTabClick("Home")}
                      >
                        Home
                      </Link>
                      <Link
                        to="/katbook"
                        className={`header_content_font textDecvor ${
                          activeTab === "KATBOOK" ? "fw-bold glass-btn" : ""
                        }`}
                        onClick={() => handleTabClick("KATBOOK")}
                      >
                        KATBOOK
                      </Link>
                      <Link
                        to="/ueducate"
                        className={`header_content_font textDecvor ${
                          activeTab === "UEducate" ? "fw-bold glass-btn" : ""
                        }`}
                        onClick={() => handleTabClick("UEducate")}
                      >
                        UEducate
                      </Link>
                      <Link
                        to="/feedback"
                        className={`header_content_font textDecvor ${
                          activeTab === "Evaluation" ? "fw-bold glass-btn" : ""
                        }`}
                        onClick={() => handleTabClick("Evaluation")}
                      >
                        Feedback
                      </Link>
                      <div
                        className="header_content_font_register px-2 "
                        onClick={() => {
                          setRegisterModal(!registerModal);
                        }}
                      >
                        Register
                      </div>
                      <div
                        className={`header_content_font login-mob ${
                          activeTab === "Login" ? "fw-bold" : ""
                        }`}
                        onClick={() => {
                          setLoginRoleModal(true);
                        }}
                      >
                        Login
                      </div>
                    </div>
                  </div> */}
                </div>
              </MediaQuery>
            </div>
          </div>
        </div>
      )}

      <ModalComponent
        show={showUserModal}
        onClick={() => setShowUserModal(false)}
        Title=""
        Content={userContent}
        dialogClassName={"registerPopup"}
        // size="md"
        isGradient={false}
      />

      <ModalComponent
        size={"md"}
        show={registerModal}
        onClick={() => {
          setRegisterModal(false);
        }}
        Content={
          //   <div>
          //   <div>
          <div className="row mb-2">
            <div className="Select_Register">
              {/* <div className="col-md-4 mb-2">
                <div className="d-flex flex-column align-items-center gap-1">
                  <div
                    className=""
                    onClick={() => {
                      setRegisterModal(false);
                      setAdminregisterModal(true);
                      setAreaName("");
                      setCityName("");
                      setStateName("");
                      setCountryName("");
                      setPincode("");
                      setEmail("");
                    }}
                  >
                    <img
                      src="https://cdn.katbook.com/assets/sites/ncert/754664530746937344_Parentreg.png"
                      className="registerImgborder"
                    />
                  </div>
                  <div className="fontregistModal">
                    {lang === "en" ? "Admin" : lang === "hi" ? "छात्र" : null}
                  </div>
                </div>
              </div> */}

              <div className="col-md-6 mb-2">
                <div className="d-flex flex-column align-items-center gap-1">
                  <div
                    className=""
                    onClick={() => {
                      setRegisterModal(false);
                      setStudentRegisterModal(true);
                      setAreaName("");
                      setCityName("");
                      setStateName("");
                      setCountryName("");
                      setPincode("");
                      setEmail("");
                      setAreaSingleData(false);
                      setViewAddressField(false);
                      setUserCredentials({
                        userId: "",
                        password: "",
                        type: ""
                      });
                    }}
                  >
                    <img
                      src="https://cdn.katbook.com/assets/sites/ncert/754664530830823424_Studentreg.png"
                      className="registerImgborder"
                    />
                  </div>
                  <div className="fontregistModal">
                    {lang === "en"
                      ? "Students"
                      : lang === "hi"
                      ? "छात्र"
                      : null}
                  </div>
                </div>
              </div>

              {/* <div className="col-md-4 mb-2">
                <div className="d-flex flex-column align-items-center gap-1">
                  <div
                    className=""
                    onClick={() => {
                      setRegisterModal(false);
                      setParentRegisterModal(true);
                      setAreaName("");
                      setCityName("");
                      setStateName("");
                      setCountryName("");
                      setPincode("");
                      setEmail("");
                    }}
                  >
                    <img
                      src="https://cdn.katbook.com/assets/sites/ncert/754664530746937344_Parentreg.png"
                      className="registerImgborder"
                    />
                  </div>
                  <div className="fontregistModal">Parents</div>
                </div>
              </div> */}

              <div className="col-md-6 mb-3">
                <div className="d-flex flex-column align-items-center gap-1">
                  <div
                    className=""
                    onClick={() => {
                      setRegisterModal(false);
                      setTeacherregisterModal(true);
                      setAreaName("");
                      setCityName("");
                      setStateName("");
                      setCountryName("");
                      setPincode("");
                      setEmail("");
                      setAreaSingleData(false);
                      setViewAddressField(false);
                      setUserCredentials({
                        userId: "",
                        password: "",
                        type: ""
                      });
                    }}
                  >
                    <img
                      src="https://cdn.katbook.com/assets/sites/ncert/754664530784686080_Teacherreg.png"
                      className="registerImgborder"
                      priority="high"
                    />
                  </div>
                  <div className="fontregistModal">
                    {lang === "en"
                      ? "Teachers"
                      : lang === "hi"
                      ? "शिक्षकों"
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      />

      <ModalComponent
        size={"md"}
        show={LoginRoleModal}
        onClick={() => {
          setLoginRoleModal(false);
        }}
        Content={
          //   <div>
          //   <div>
          <div className="row mb-2">
            <div className="Select_Register">
              <div className="col-md-6 mb-2">
                <div className="d-flex flex-column align-items-center gap-1">
                  <div
                    className=""
                    onClick={() => {
                      setLoginRoleModal(false);
                      setLoginModal(true);
                      setroleName("Student");
                    }}
                  >
                    <img
                      src="https://cdn.katbook.com/assets/sites/ncert/754664530830823424_Studentreg.png"
                      className="registerImgborder"
                    />
                  </div>
                  <div className="fontregistModal">
                    {lang === "en"
                      ? "Students"
                      : lang === "hi"
                      ? "छात्र"
                      : null}
                  </div>
                </div>
              </div>

              {/* <div className="col-md-4 mb-2">
                <div className="d-flex flex-column align-items-center gap-1">
                  <div
                    className=""
                    onClick={() => {
                      setLoginRoleModal(false);
                      setLoginModal(true);
                      setroleName("Parent");
                    }}
                  >
                    <img
                      src="https://cdn.katbook.com/assets/sites/ncert/754664530746937344_Parentreg.png"
                      className="registerImgborder"
                    />
                  </div>
                  <div className="fontregistModal">Parents</div>
                </div>
              </div> */}

              <div className="col-md-6 mb-3">
                <div className="d-flex flex-column align-items-center gap-1">
                  <div
                    className=""
                    onClick={() => {
                      setLoginRoleModal(false);
                      setLoginModal(true);
                      setroleName("Teacher");
                    }}
                  >
                    <img
                      src="https://cdn.katbook.com/assets/sites/ncert/754664530784686080_Teacherreg.png"
                      className="registerImgborder"
                      priority="high"
                    />
                  </div>
                  <div className="fontregistModal">
                    {" "}
                    {lang === "en"
                      ? "Teachers"
                      : lang === "hi"
                      ? "शिक्षकों"
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      />

      {/* Student Registration Modal */}
      <ModalComponent
        // size={"xl"}
        dialogClassName={"register_modal"}
        show={studentregisterModal}
        Title={
          lang === "en"
            ? "Student Registration"
            : lang === "hi"
            ? "छात्रों का पंजीकरण"
            : null
        }
        onClick={() => {
          setStudentRegisterModal(false);
          emptyState();
        }}
        className={"Register_insidescroll"}
        Content={
          <div>
            <div className="container">
              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "First Name"
                        : lang === "hi"
                        ? "प्रथम नाम"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? "Enter First Name"
                        : lang === "hi"
                        ? "प्रथम नाम दर्ज करें"
                        : null
                    }
                    maxLength={15}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={state.firstName}
                    onChange={(e) => {
                      // if (!regexName.test(e.target.value.trim())) return;
                      const userInput = e.target.value.trim();
                      const concatenatedValue =
                        userInput.trim() + state.lastName.trim();
                      const finalValue = concatenatedValue.replace(/\s+/g, ""); // Remove spaces
                      setState({
                        ...state,
                        firstName: userInput,
                        user: `${finalValue}`,
                        suggestion: false,
                        suggestionCard: false,
                      });
                      setcheckusernotify("");
                      setsuccesscheckusernotify("");
                    }}
                    // isDisabled={studentregisterModal ? false : true}
                  />
                  {state.firstName && !regexName.test(state.firstName) && (
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div className="sugesstionFontred d-flex align-items-center gap-1">
                        <FaExclamationCircle /> First name allow only letters & Max 15 characters
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "Last Name"
                        : lang === "hi"
                        ? "उपनाम"
                        : null
                    }
                    optionField={true}
                    maxLength={15}
                    placeholder={
                      lang === "en"
                        ? "Enter Last Name"
                        : lang === "hi"
                        ? "उपनाम दर्ज करें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={state.lastName}
                    onChange={(e) => {
                      // if (!regexName.test(e.target.value.trim())) return;
                      const userInput = e.target.value.trim();
                      const concatenatedValue =
                        state.firstName.trim() + userInput.trim();
                      const finalValue = concatenatedValue.replace(/\s+/g, ""); // Remove spaces
                      setState({
                        ...state,
                        lastName: userInput,
                        user: `${finalValue}`,
                        suggestion: false,
                        suggestionCard: false,
                      });
                      setcheckusernotify("");
                      setsuccesscheckusernotify("");
                    }}
                    isDisabled={
                      state.firstName && regexName.test(state.firstName)
                        ? false
                        : true
                    }
                  />
                  {state.lastName && !regexName.test(state.lastName) && (
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div className="sugesstionFontred d-flex align-items-center gap-1">
                        <FaExclamationCircle /> Last name allow only letters & Max 15 characters
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en" ? "Gender" : lang === "hi" ? "लिंग" : null
                    }
                    Selectplaceholder={
                      lang === "en"
                        ? "Select Gender"
                        : lang === "hi"
                        ? "लिंग चुनें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2 dropdown_font_css"}
                    isDropdown
                    value={state.gender}
                    options={options[1]}
                    onChange={(e) => {
                      setState({ ...state, gender: e });
                    }}
                    isDisabled={state.firstName ? false : true}
                  />
                </div>

                <div className="col-md-6">
                  <Input
                    label={"Country"}
                    Selectplaceholder={"Select Country"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2 dropdown_font_css"}
                    isDropdown
                    value={selectedCountry}
                    options={allCountries}
                    onChange={(e) => {
                      setselectedCountry(e);
                      setState({ ...state, number: "" });
                    }}
                    isDisabled={state.gender?.value ? false : true}
                  />
                </div>

                
              </div>

              <div className="row pt-2 input_gap">

                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "Parent's Mobile No"
                        : lang === "hi"
                        ? "अभिभावकों का मोबाइल नं"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? `Enter Parent's Mobile No ${selectedCountry?.maxLength ? `(${selectedCountry?.maxLength} digits)` : ""}`
                        : lang === "hi"
                        ? `अभिभावकों का मोबाइल नं दर्ज करें ${selectedCountry?.maxLength ? `(${selectedCountry?.maxLength} अंक)` : ""}`
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={state.number}
                    onChange={(e) => handlePhoneNumberChange(e, setState)}
                    isDisabled={state.gender?.value && selectedCountry?.value ? false : true}
                  />
                  {selectedCountry?.minLength && state?.number && state?.number?.length >= selectedCountry?.minLength && state?.number?.length !== selectedCountry?.maxLength && (
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div className="sugesstionFontred d-flex align-items-center gap-1">
                        <FaExclamationCircle /> Please enter {selectedCountry?.maxLength} digits mobile no
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "Email ID"
                        : lang === "hi"
                        ? "ईमेल आईडी"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? "Enter Email ID"
                        : lang === "hi"
                        ? "ईमेल आईडी दर्ज करें"
                        : null
                    }
                    optionField={selectedCountry?.dialingCode === "+91" ? true : false}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={email}
                    onChange={handleEmailChange}
                    isDisabled={state.number.length !== selectedCountry?.maxLength}
                  />
                  {emailError && (
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div className="sugesstionFontred d-flex align-items-center gap-1">
                        <FaExclamationCircle /> {emailError}
                      </div>
                    </div>
                  )}
                </div>

                
              </div>

              <div className="row pt-2 input_gap">
                  <div className="col-md-12">
                  <div
                    className="position-relative w-100"
                    ref={stateSchoolWrapperRef}
                  >
                    <Input
                      label={
                        lang === "en"
                          ? "School Name"
                          : lang === "hi"
                          ? "स्कूल के नाम"
                          : null
                      }
                      placeholder={
                        lang === "en"
                          ? "Enter School Name"
                          : lang === "hi"
                          ? "स्कूल का नाम दर्ज करें"
                          : null
                      }
                      labelClassName={"Select_label"}
                      className={"input-size p-2"}
                      value={state.schoolName}
                      onChange={handleSchoolChange}
                      isDisabled={state.number.length !== selectedCountry?.maxLength}
                      onBlur={() =>
                        setTimeout(
                          () =>
                            setState((prev) => ({
                              ...prev,
                              suggestion: false,
                            })),
                          200
                        )
                      }
                      onFocus={() =>
                        schoolList.length > 0 &&
                        setState((prev) => ({ ...prev, suggestion: true }))
                      }
                    />

                    {showSuggestions &&
                      schoolList.length > 0 &&
                      state.schoolName.trim() !== "" && (
                        <ul className="suggestion-list">
                          {schoolList.map((item, idx) => (
                            <li
                              key={idx}
                              onClick={() => handleSelectSchool(item.school)}
                              className="suggestion-item"
                            >
                              {item.school}
                            </li>
                          ))}
                        </ul>
                      )}
                  </div>
                </div>
              </div>

              <div className="row pt-2 input_gap">
                <div className="col-md-6 pt-2">
                  <Input
                    label={
                      lang === "en"
                        ? "School Pincode"
                        : lang === "hi"
                        ? "पिनकोड"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? `Enter School Pincode ${selectedCountry?.dialingCode === "+91" ? `(6 digits)` : ""}`
                        : lang === "hi"
                        ? `पिनकोड दर्ज करें ${selectedCountry?.dialingCode === "+91" ? `(6 अंक)` : ""}`
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={pincode}
                    onChange={handlePincodeChange}
                    maxLength={selectedCountry?.dialingCode === "+91" ? 6 : ""}
                    type="text"
                    inputMode="numeric"
                    isDisabled={state?.schoolName?.length > 0 ? false : true}
                  />
                </div>

                <div className="col-md-6 pt-2">
                  <Input
                    label={
                      lang === "en"
                        ? "Class in which you are studying"
                        : lang === "hi"
                        ? "कक्षा"
                        : null
                    }
                    Selectplaceholder={
                      lang === "en"
                        ? "Select Class"
                        : lang === "hi"
                        ? "कक्षा का चयन करें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isDropdown
                    options={classList}
                    value={studentClass}
                    onChange={(e) => {
                      setStudentClass(e);
                    }}
                    isDisabled={selectedCountry?.dialingCode === "+91" ? ((pincode.length === 6 && stateName !== "") ? false : true) : (pincode.length > 0 ? false : true)}
                  />
                </div>
              </div>

              <div className="col-md-12 d-flex flex-column gap-2 justify-content-center align-items-center modal-dropdown-size pt-2">
                <div className="col-md-6 Register_input gap-2 w-100">
                  <div className="d-flex flex-column w-100 relative">
                    <Input
                      label={
                        lang === "en"
                          ? "User Id"
                          : lang === "hi"
                          ? "प्रयोक्ता आईडी"
                          : null
                      }
                      placeholder={
                        lang === "en"
                          ? "User Id"
                          : lang === "hi"
                          ? "यूजर आईडी सेट करें"
                          : null
                      }
                      labelClassName={"Select_label"}
                      className={"input-size p-2"}
                      value={state.user ? `${state.user.toLowerCase()}` : ""}
                      onChange={(e) => {
                        setState({ ...state, user: e.target.value.toLowerCase() });
                      }}
                      isDisabled={!studentClass}
                    />
                    {studentClass && state.user && !userIdregex.test(state.user) && (
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div className="sugesstionFontred d-flex align-items-center gap-1">
                        <FaExclamationCircle /> User Id allow only letters and digits & at least 4 and at most 20 characters
                      </div>
                    </div>
                    )}
                  </div>
                  <>
                    <div className="d-flex flex-column w-100 relative">
                      {/* Password Field */}
                      <div>
                        <Input
                          label={
                            lang === "en"
                              ? "Password"
                              : lang === "hi"
                              ? "पासवर्ड"
                              : null
                          }
                          placeholder={
                            lang === "en"
                              ? "Enter Password"
                              : lang === "hi"
                              ? "पासवर्ड सेट करें"
                              : null
                          }
                          labelClassName={"Select_label"}
                          className={"input-size p-2"}
                          isPassword
                          value={state.pwd}
                          onChange={(e) => {
                            setState({ ...state, pwd: e.target.value });
                          }}
                          isDisabled={studentClass && state.user ? false : true}
                        />
                      </div>

                      <div>
                        {state.pwd &&
                          !pswdregex.test(
                            state.pwd
                          ) && (
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <div className="sugesstionFontred d-flex align-items-center gap-1">
                                <FaExclamationCircle />
                                Password must have 1 capital letter, 1 number, 1
                                symbol & min 6 chars
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="d-flex flex-column w-100 relative">
                      <div>
                        <Input
                          label={
                            lang === "en"
                              ? "Confirm Password"
                              : lang === "hi"
                              ? "पासवर्ड की पुष्टि कीजिये"
                              : null
                          }
                          placeholder={
                            lang === "en"
                              ? "Enter Confirm Password"
                              : lang === "hi"
                              ? "सांकेतिक शब्द लगना"
                              : null
                          }
                          labelClassName={"Select_label"}
                          className={"input-size p-2"}
                          isPassword
                          value={state.confirmPwd}
                          onChange={handleConfirmPasswordChangeStu}
                          isDisabled={
                            !pswdregex.test(
                              state.pwd
                            )
                          }
                        />
                      </div>
                      <div>
                        {state.pwd &&
                          state.confirmPwd &&
                          state.pwd !== state.confirmPwd && (
                            <>
                              <div className="d-flex justify-content-between align-items-center w-100">
                                <div className="sugesstionFontred d-flex align-items-center gap-1">
                                  <FaExclamationCircle /> Passwords do not match
                                </div>
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                  </>
                  <button
                    className="btn btn-success butonRegister mt-4 mb-3"
                    onClick={() => {
                      if (state.number.length !== selectedCountry?.maxLength) {
                        toast.error(`Please enter ${selectedCountry?.maxLength} digits mobile no`);
                      } else {
                        setregistertype("student-registration");
                        setmobilenumber(state.number);
                        studentregisterfunc();
                        setSecondsPassed(0);
                        setTimerActive(true);
                        setisResend(true);
                        setRegisterStudDis(true);
                      }
                    }}
                    disabled={
                      !(
                        state.confirmPwd && pswdregex.test(state.pwd) &&
                        state.pwd === state.confirmPwd &&
                        pincode && state.user && userIdregex.test(state.user) && state.schoolName && state.number && state.firstName && regexName.test(state.firstName)
                      ) || registerStudDis || (!state?.lastName ? false : (state?.lastName && state?.lastName !== "" && regexName.test(state.lastName) ? false : true)) || ((!email && selectedCountry?.dialingCode === "+91") ? false : (!email && selectedCountry?.dialingCode !== "+91") ? true : (email && email !== "" && emailError === "" ? false : true))
                    }
                  >
                    {lang === "en"
                      ? "Register"
                      : lang === "hi"
                      ? "पंजीकरण"
                      : null}
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      />
      {/* Student Registration Modal */}

      {/* Parents Modal */}
      <ModalComponent
        dialogClassName={"register_modal"}
        show={ParentregisterModal}
        Title={"Parents Registration"}
        className={"Register_insidescroll"}
        onClick={() => {
          setParentRegisterModal(false);
          emptyStateParent();
        }}
        Content={
          <div>
            <div className="container">
              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={"First Name"}
                    placeholder={"Enter First Name"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={parentState.firstName}
                    onChange={(e) => {
                      const userInput = e.target.value.trim();
                      const concatenatedValue =
                        userInput.trim() + parentState.lastName.trim();
                      const finalValue = concatenatedValue.replace(/\s+/g, "");
                      setparentState({
                        ...parentState,
                        firstName: userInput,
                        user: finalValue,
                        suggestion: false,
                        suggestionCard: false,
                      });
                      setsuccesscheckusernotify("");
                      setcheckusernotify("");
                    }}
                  />
                  {parentState.firstName &&
                    !regexName.test(parentState.firstName) && (
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="sugesstionFontred d-flex align-items-center gap-1">
                          <FaExclamationCircle /> First name allow only letters
                        </div>
                      </div>
                    )}
                </div>

                <div className="col-md-6">
                  <Input
                    label={"Last Name"}
                    placeholder={"Enter Last Name"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={parentState.lastName}
                    onChange={(e) => {
                      const userInput = e.target.value.trim();
                      const concatenatedValue =
                        parentState.firstName.trim() + userInput.trim();
                      const finalValue = concatenatedValue.replace(/\s+/g, "");
                      setparentState({
                        ...parentState,
                        lastName: userInput,
                        user: finalValue,
                        suggestion: false,
                        suggestionCard: false,
                      });
                      setsuccesscheckusernotify("");
                      setcheckusernotify("");
                    }}
                    isDisabled={
                      parentState.firstName &&
                      regexName.test(parentState.firstName)
                        ? false
                        : true
                    }
                  />
                  {parentState.lastName &&
                    !regexName.test(parentState.lastName) && (
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="sugesstionFontred d-flex align-items-center gap-1">
                          <FaExclamationCircle /> Last name allow only letters
                        </div>
                      </div>
                    )}
                </div>
              </div>

              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={"Date of Birth"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isDate={true}
                    maxDate={moment()
                      .subtract(18, "years")
                      .format("YYYY-MM-DD")}
                    value={parentState.birth}
                    onChange={(e) => {
                      setparentState({ ...parentState, birth: e.target.value });
                    }}
                    isDisabled={
                      parentState.lastName &&
                      regexName.test(parentState.lastName)
                        ? false
                        : true
                    }
                  />
                </div>

                <div className="col-md-6">
                  <Input
                    label={"Mobile No"}
                    placeholder={"Enter Mobile No"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={parentState.number}
                    // onChange={(e) => {
                    //   setparentState({
                    //     ...parentState,
                    //     number: e.target.value,
                    //   });
                    // }}
                    onChange={(e) => handlePhoneNumberChange(e, setparentState)}
                    isDisabled={parentState.birth ? false : true}
                  />
                </div>
              </div>

              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={"Email ID"}
                    placeholder={"Enter Email ID"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={email}
                    onChange={handleEmailChange}
                    isDisabled={parentState.number.length !== 10}
                  />
                  {emailError && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "4px",
                      }}
                    >
                      {emailError}
                    </p>
                  )}
                </div>
                <div className="col-md-6">
                  <Input
                    label={"Select Relationship"}
                    Selectplaceholder={"Select"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isDropdown
                    value={parentState.relation}
                    options={selctGaurd}
                    onChange={(e) => {
                      {
                        console.log(e, "testggg");
                      }
                      guardOnChange(e);
                      setparentState({
                        ...parentState,
                        relation: e,
                        gender: "", // Use e.value instead of e.target.value
                        StudentId: "",
                        suggestion: false,
                        suggestionCard: false,
                      });
                      setsuccesscheckusernotify("");
                      setcheckusernotify("");
                    }}
                    isDisabled={emailError || !email}
                  />
                </div>
              </div>

              <div className="row pt-2 input_gap">
                {gaurdShow ? (
                  <div className="col-md-6">
                    <Input
                      label={"Gender"}
                      Selectplaceholder={"Select Gender"}
                      labelClassName={"Select_label"}
                      className={"input-size p-2"}
                      isDropdown
                      options={options[1]}
                      value={parentState.gender}
                      onChange={(e) => {
                        setparentState({
                          ...parentState,
                          gender: e,
                          StudentId: "",
                        });
                      }}
                    />
                  </div>
                ) : (
                  <div className="col-md-6">
                    <Input
                      label={"Student Id"}
                      placeholder={"Student Id"}
                      labelClassName={"Select_label"}
                      className={"input-size p-2"}
                      value={parentState.StudentId}
                      onChange={(e) => {
                        setparentState({
                          ...parentState,
                          StudentId: e.target.value,
                        });
                        setuserdetailshow(false);
                      }}
                      isDisabled={parentState.relation ? false : true}
                      showRightIcon={
                        <div
                          onClick={() => {
                            getuserdetailsbyId();
                          }}
                          className="cursor-pointer checkFont"
                        >
                          Check
                        </div>
                      }
                    />
                    {/* <input
          type="checkbox"
          checked={parentState.checkvalue}
          onChange={handleUserCheckboxChange}
        /> */}
                  </div>
                )}
              </div>

              <div className="row pt-2 ">
                {gaurdShow && (
                  <div className="col-md-6">
                    <Input
                      label={"Student Id"}
                      placeholder={"Student Id"}
                      labelClassName={"Select_label"}
                      className={"input-size p-2"}
                      value={parentState.StudentId}
                      onChange={(e) => {
                        setparentState({
                          ...parentState,
                          StudentId: e.target.value,
                        });
                        setuserdetailshow(false);
                      }}
                      isDisabled={parentState.gender ? false : true}
                      showRightIcon={
                        <div
                          onClick={() => {
                            getuserdetailsbyId();
                          }}
                          className="cursor-pointer checkFont"
                        >
                          Check
                        </div>
                      }
                    />
                    <div></div>
                  </div>
                )}
              </div>
              {parentState.StudentId && userdetailshow && (
                <div className="col-md-12 d-flex flex-row gap-5 w-100 mt-3">
                  <div className="studentdetailsBack">
                    {userdetails.map((user) => (
                      <div>
                        <div key={user.userId}>
                          <div className="d-flex justify-content-between py-2 px-3">
                            <div className="d-flex flex-column gap-2 justify-content-center ">
                              <div className="headstudentDetails">
                                Student Name
                              </div>
                              <div className="headstudentDetailsContent">
                                {`${user.firstName} ${user.lastName}`}
                              </div>
                            </div>
                            <div className="d-flex flex-column gap-2 justify-content-center ">
                              <div className="headstudentDetails">School</div>
                              <div className="headstudentDetailsContent">
                                {user.schoolName}
                                {/* {console.log(userdetails[0].schoolName,"testcccccc")} */}
                              </div>
                            </div>
                            <div className="d-flex flex-column gap-2 justify-content-center ">
                              <div className="headstudentDetails">Standard</div>
                              <div className="headstudentDetailsContent">
                                {user.standard[0]?.variableName}
                              </div>
                            </div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>

                        <div className="d-flex justify-content-between py-2 px-3">
                          <div className="d-flex flex-column gap-2 justify-content-center ">
                            <div className="headstudentDetails">Subject</div>
                            <div className="headstudentDetailsContent">
                              {/* {user.subject && user.standard[0]?.variableName && user.subject[user.standard[0]?.variableName] ? (
        user.subject[user.standard[0]?.variableName].map((subject, index) => (
            <span key={index}>{subject.parentVaribaleId.variableName}, </span>
        ))
    ) : (
        <span>No subjects available</span>

    )} */}

                              {user.subject.map((subject) => (
                                <span key={subject._id}>
                                  {subject.parentVaribaleId.variableName},{" "}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <hr style={{ border: "2px dashed black" }} />
              <div className="col-md-12 d-flex flex-column gap-2 justify-content-center align-items-center modal-dropdown-size">
                <div className="col-md-6 Register_input gap-2 w-100">
                  <div className="d-flex flex-column w-100 relative">
                    {parentState.suggestionCard && (
                      <div className="suggestionAbsolute">
                        {usernamesuggestion.map((name, index) => (
                          <div
                            key={index}
                            className={`d-flex flex-column ${
                              selectedSuggestionparent === name
                                ? "selected"
                                : ""
                            }`}
                            onClick={() => {
                              handleSuggestionClickparent(name);
                              setsuccesscheckusernotify("");
                              setcheckusernotify("");
                            }}
                          >
                            <div className="textDecvor sugesteGetFont border-bottom py-1 px-2">
                              {/* SAkashpandurangan07 */}
                              {name}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <Input
                      label={"User Id"}
                      placeholder={"User Id"}
                      labelClassName={"Select_label"}
                      className={"input-size p-2"}
                      value={
                        parentState.relation.value === "Father"
                          ? `F${parentState.user}`
                          : parentState.relation.value === "Mother"
                          ? `M${parentState.user}`
                          : parentState.relation.value === "Guardian"
                          ? `G${parentState.user}`
                          : `${parentState.user}`
                      }
                      showRightIcon={
                        <div
                          onClick={() => {
                            if (
                              parentState.relation.value &&
                              parentState.firstName &&
                              parentState.lastName &&
                              checksuccessusernotify === ""
                            ) {
                              checkuseridfun("parent");
                            }
                          }}
                          style={{
                            cursor:
                              parentState.relation.value &&
                              parentState.user &&
                              parentState.lastName &&
                              parentState.firstName &&
                              checksuccessusernotify === ""
                                ? "pointer"
                                : "default",
                            color: checksuccessusernotify ? "#c1c1c1" : "",
                          }}
                          className={
                            parentState.relation.value &&
                            parentState.firstName &&
                            parentState.lastName
                              ? `cursor-pointer checkFont`
                              : `checkFont`
                          }
                        >
                          Check
                        </div>
                      }
                      isDisabled={true}
                    />

                    <div className="align-items-center w-100">
                      {checkusernotify && (
                        <div className="sugesstionFontred d-flex align-items-center gap-1">
                          <FaExclamationCircle /> {checkusernotify}
                        </div>
                      )}
                      {checksuccessusernotify && (
                        <div className="sugesstionFontgreen d-flex align-items-center gap-1">
                          <IoIosCheckmarkCircle /> {checksuccessusernotify}
                        </div>
                      )}
                      {parentState.suggestion && (
                        <div
                          className="sugesstionFonblack cursor-pointer"
                          onClick={() => {
                            setparentState({
                              ...parentState,
                              suggestionCard: true,
                            });
                            useridsuggestionlist("parent");
                          }}
                        >
                          Get Suggestion
                        </div>
                      )}
                    </div>
                  </div>
                  <Input
                    label={"Password"}
                    placeholder={"Set Password"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isPassword
                    value={parentState.pwd}
                    onChange={(e) => {
                      setparentState({ ...parentState, pwd: e.target.value });
                    }}
                    isDisabled={!userdetailshow}
                  />
                  <div className="d-flex flex-column w-100 relative">
                    <div>
                      <Input
                        label={"Confirm Password"}
                        placeholder={"Set Password"}
                        labelClassName={"Select_label"}
                        className={"input-size p-2"}
                        isPassword
                        value={parentState.confirmPwd}
                        // onChange={(e) => {
                        //     setparentState({
                        //         ...parentState,
                        //         confirmPwd: e.target.value,
                        //     });
                        // }}
                        onChange={handleConfirmPasswordChangePar}
                        isDisabled={parentState.pwd ? false : true}
                      />
                    </div>
                    <div>
                      {parentState.pwd &&
                        parentState.confirmPwd &&
                        parentState.pwd !== parentState.confirmPwd && (
                          <>
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <div className="sugesstionFontred d-flex align-items-center gap-1">
                                <FaExclamationCircle /> Passwords do not match
                              </div>
                            </div>
                          </>
                        )}
                    </div>
                  </div>
                  <button
                    className="btn btn-success butonRegister margin_mobiles mt-4 mb-3"
                    onClick={() => {
                      if (parentState.number.length !== 10) {
                        toast.error("Please enter 10 digit mobile no");
                      } else {
                        setregistertype("parent-registration");
                        setmobilenumber(parentState.number);
                        parentregisterfunc();
                        setSecondsPassed(0);
                        setTimerActive(true);
                        setisResend(true);
                      }
                    }}
                    disabled={
                      parentState.confirmPwd &&
                      parentState.pwd === parentState.confirmPwd &&
                      parentState.StudentId &&
                      userdetailshow
                        ? false
                        : true
                    }
                    // disabled={
                    //   isLoadingreg
                    //     ? isLoadingreg
                    //     : checksuccessusernotify &&
                    //       parentState.confirmPwd &&
                    //       parentState.pwd === parentState.confirmPwd &&
                    //       parentState.StudentId &&
                    //       userdetailshow
                    //     ? false
                    //     : true
                    // }
                  >
                    Register
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      />
      {/* Parents Modal */}

      {/* Teacher Modal */}
      <ModalComponent
        dialogClassName={"register_modal"}
        show={TeacherregisterModal}
        Title={
          lang === "en"
            ? "Teacher Registration"
            : lang === "hi"
            ? "शिक्षक पंजीकरण"
            : null
        }
        className={"Register_insidescroll"}
        onClick={() => {
          setTeacherregisterModal(false);
          emptyStateTeacher();
        }}
        Content={
          <div>
            <div className="container">
              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "First Name"
                        : lang === "hi"
                        ? "प्रथम नाम"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? "Enter First Name"
                        : lang === "hi"
                        ? "प्रथम नाम दर्ज करें"
                        : null
                    }
                    maxLength={15}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={stateTeacher.firstName}
                    onChange={(e) => {
                      const userInput = e.target.value.trim();
                      const concatenatedValue =
                        userInput.trim() + stateTeacher.lastName.trim();
                      const finalValue = concatenatedValue.replace(/\s+/g, "");
                      setStateTeacher({
                        ...stateTeacher,
                        firstName: userInput,
                        user: `${finalValue}`,
                        suggestion: false,
                        suggestionCard: false,
                      });
                      setsuccesscheckusernotify("");
                      setcheckusernotify("");
                    }}
                    // isDisabled={TeacherregisterModal ? false : true}
                  />
                  {stateTeacher.firstName &&
                    !regexName.test(stateTeacher.firstName) && (
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="sugesstionFontred d-flex align-items-center gap-1">
                          <FaExclamationCircle /> First name allow only letters & Max 15 characters
                        </div>
                      </div>
                    )}
                </div>
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "Last Name"
                        : lang === "hi"
                        ? "उपनाम"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? "Enter Last Name"
                        : lang === "hi"
                        ? "उपनाम दर्ज करें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    optionField={true}
                    maxLength={15}
                    className={"input-size p-2"}
                    value={stateTeacher.lastName}
                    onChange={(e) => {
                      const userInput = e.target.value.trim();
                      const concatenatedValue =
                        stateTeacher.firstName.trim() + userInput.trim();
                      const finalValue = concatenatedValue.replace(/\s+/g, "");
                      setStateTeacher({
                        ...stateTeacher,
                        lastName: userInput,
                        user: `${finalValue}`,
                        suggestion: false,
                        suggestionCard: false,
                      });
                      setsuccesscheckusernotify("");
                      setcheckusernotify("");
                    }}
                    isDisabled={
                      stateTeacher.firstName &&
                      regexName.test(stateTeacher.firstName)
                        ? false
                        : true
                    }
                  />
                  {stateTeacher.lastName &&
                    !regexName.test(stateTeacher.lastName) && (
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="sugesstionFontred d-flex align-items-center gap-1">
                          <FaExclamationCircle /> Last name allow only letters & Max 15 characters
                        </div>
                      </div>
                    )}
                </div>
              </div>

              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en" ? "Gender" : lang === "hi" ? "लिंग" : null
                    }
                    Selectplaceholder={
                      lang === "en"
                        ? "Select Gender"
                        : lang === "hi"
                        ? "लिंग चुनें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isDropdown
                    options={options[1]}
                    value={stateTeacher.gender}
                    onChange={(e) => {
                      setStateTeacher({
                        ...stateTeacher,
                        gender: e,
                      });
                    }}
                    isDisabled={stateTeacher.firstName ? false : true}
                  />
                </div>

                <div className="col-md-6">
                  <Input
                    label={"Country"}
                    Selectplaceholder={"Select Country"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2 dropdown_font_css"}
                    isDropdown
                    value={selectedCountry}
                    options={allCountries}
                    onChange={(e) => {
                      setselectedCountry(e);
                      setStateTeacher({ ...stateTeacher, number: "" });
                    }}
                    isDisabled={stateTeacher.gender?.value ? false : true}
                  />
                </div>

              </div>

              <div className="row pt-2 input_gap">

                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "Mobile No"
                        : lang === "hi"
                        ? "मोबाइल नं"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? `Enter Mobile No ${selectedCountry?.maxLength ? `(${selectedCountry?.maxLength} digits)` : ""}`
                        : lang === "hi"
                        ? `मोबाइल नं दर्ज करें ${selectedCountry?.maxLength ? `(${selectedCountry?.maxLength} अंक)` : ""}`
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={stateTeacher.number}
                    onChange={(e) =>
                      handlePhoneNumberChange(e, setStateTeacher)
                    }
                    isDisabled={stateTeacher.gender?.value && selectedCountry?.value ? false : true}
                  />
                  {selectedCountry?.minLength && stateTeacher?.number && stateTeacher?.number?.length >= selectedCountry?.minLength && stateTeacher?.number?.length !== selectedCountry?.maxLength && (
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div className="sugesstionFontred d-flex align-items-center gap-1">
                        <FaExclamationCircle /> Please enter {selectedCountry?.maxLength} digits mobile no
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "Email ID"
                        : lang === "hi"
                        ? "ईमेल आईडी"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? "Enter Email ID"
                        : lang === "hi"
                        ? "ईमेल आईडी दर्ज करें"
                        : null
                    }
                    optionField={selectedCountry?.dialingCode === "+91" ? true : false}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={email}
                    onChange={handleEmailChange}
                    isDisabled={stateTeacher.number.length !== selectedCountry?.maxLength}
                  />
                  {emailError && (
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div className="sugesstionFontred d-flex align-items-center gap-1">
                        <FaExclamationCircle /> {emailError}
                      </div>
                    </div>
                  )}
                </div>
                
              </div>

              <div className="row pt-2 input_gap">
                <div className="col-md-12">
                  <div
                    className="position-relative w-100"
                    ref={stateSchoolTeacherWrapperRef}
                  >
                    <Input
                      label={
                        lang === "en"
                          ? "School Name"
                          : lang === "hi"
                          ? "स्कूल के नाम"
                          : null
                      }
                      placeholder={
                        lang === "en"
                          ? "Enter School Name"
                          : lang === "hi"
                          ? "स्कूल का नाम दर्ज करें"
                          : null
                      }
                      labelClassName={"Select_label"}
                      className={"input-size p-2"}
                      value={stateTeacher.schoolName}
                      onChange={handleSchoolChangeTeacher}
                      isDisabled={stateTeacher.number.length !== selectedCountry?.maxLength}
                      onBlur={() =>
                        setTimeout(
                          () =>
                            setStateTeacher((prev) => ({
                              ...prev,
                              suggestion: false,
                            })),
                          200
                        )
                      }
                      onFocus={() =>
                        setSchoolListTeacher.length > 0 &&
                        setStateTeacher((prev) => ({
                          ...prev,
                          suggestion: true,
                        }))
                      }
                    />

                    {showSuggestionsTeacher &&
                      schoolListTeacher.length > 0 &&
                      stateTeacher.schoolName.trim() !== "" && (
                        <ul className="suggestion-list">
                          {schoolListTeacher.map((item, idx) => (
                            <li
                              key={idx}
                              onClick={() =>
                                handleSelectSchoolTeacher(item.school)
                              }
                              className="suggestion-item"
                            >
                              {item.school}
                            </li>
                          ))}
                        </ul>
                      )}
                  </div>
                </div>
              </div>

              <div className="row pt-2 input_gap">
                <div className="col-md-6 pt-2">
                  <Input
                    label={
                      lang === "en"
                        ? "School Pincode"
                        : lang === "hi"
                        ? "पिनकोड"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? `Enter School Pincode ${selectedCountry?.dialingCode === "+91" ? `(6 digits)` : ""}`
                        : lang === "hi"
                        ? `पिनकोड दर्ज करें ${selectedCountry?.dialingCode === "+91" ? `(6 अंक)` : ""}`
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={pincode}
                    onChange={handlePincodeChange}
                    maxLength={selectedCountry?.dialingCode === "+91" ? 6 : ""}
                    type="text"
                    inputMode="numeric"
                    isDisabled={
                      stateTeacher?.schoolName?.length > 0 ? false : true
                    }
                  />
                </div>
                <div className="col-md-6 pt-2">
                  <Input
                    label={
                      lang === "en"
                        ? "Class in which you are teaching"
                        : lang === "hi"
                        ? "कक्षा"
                        : null
                    }
                    Selectplaceholder={
                      lang === "en"
                        ? "Select Class in which you are teaching"
                        : lang === "hi"
                        ? "कक्षा का चयन करें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isDropdown
                    value={teacherClass}
                    onChange={(e) => {
                      setTeacherClass(e);
                    }}
                    options={classList}
                    isDisabled={selectedCountry?.dialingCode === "+91" ? ((pincode.length === 6 && stateName !== "") ? false : true) : (pincode.length > 0 ? false : true)}
                  />
                </div>
              </div>

              <div className="col-md-12 d-flex flex-column gap-2 pt-2 justify-content-center align-items-center modal-dropdown-size">
                <div className="col-md-6 Register_input gap-2 w-100 pt-2">
                  <div className="d-flex flex-column w-100 relative">
                    <Input
                      label={
                        lang === "en"
                          ? "User Id"
                          : lang === "hi"
                          ? "प्रयोक्ता आईडी"
                          : null
                      }
                      placeholder={
                        lang === "en"
                          ? "User Id"
                          : lang === "hi"
                          ? "यूजर आईडी सेट करें"
                          : null
                      }
                      labelClassName={"Select_label"}
                      className={"input-size p-2"}
                      value={stateTeacher.user ? `${stateTeacher.user.toLowerCase()}` : ""}
                      onChange={(e) => {
                        setStateTeacher({
                          ...stateTeacher,
                          user: e.target.value.toLowerCase(),
                        });
                      }}
                      isDisabled={teacherClass ? false : true}
                    />
                    {teacherClass && stateTeacher.user && !userIdregex.test(stateTeacher.user) && (
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div className="sugesstionFontred d-flex align-items-center gap-1">
                        <FaExclamationCircle /> User Id allow only letters and digits & at least 4 and at most 20 characters
                      </div>
                    </div>
                    )}
                  </div>

                  <div className="d-flex flex-column w-100 relative">
                    <div>
                      <Input
                        label={
                          lang === "en"
                            ? "Password"
                            : lang === "hi"
                            ? "पासवर्ड"
                            : null
                        }
                        placeholder={
                          lang === "en"
                            ? "Enter Password"
                            : lang === "hi"
                            ? "पासवर्ड सेट करें"
                            : null
                        }
                        labelClassName={"Select_label"}
                        className={"input-size p-2"}
                        isPassword
                        value={stateTeacher.pwd}
                        onChange={(e) => {
                          const value = e.target.value;
                          setStateTeacher({ ...stateTeacher, pwd: value });
                        }}
                        isDisabled={
                          teacherClass && stateTeacher.user ? false : true
                        }
                      />
                    </div>

                    <div>
                      {stateTeacher.pwd &&
                        !pswdregex.test(
                          stateTeacher.pwd
                        ) && (
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <div className="sugesstionFontred d-flex align-items-center gap-1">
                              <FaExclamationCircle />
                              Password must have 1 capital letter, 1 number, 1
                              symbol & min 6 chars
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="d-flex flex-column w-100 relative">
                    <div>
                      <Input
                        label={
                          lang === "en"
                            ? "Confirm Password"
                            : lang === "hi"
                            ? "पासवर्ड की पुष्टि कीजिये"
                            : null
                        }
                        placeholder={
                          lang === "en"
                            ? "Enter Confirm Password"
                            : lang === "hi"
                            ? "सांकेतिक शब्द लगना"
                            : null
                        }
                        labelClassName={"Select_label"}
                        className={"input-size p-2"}
                        isPassword
                        value={stateTeacher.confirmPwd}
                        onChange={handleConfirmPasswordChangeTec}
                        isDisabled={
                          !pswdregex.test(
                            stateTeacher.pwd
                          )
                        }
                      />
                    </div>
                    <div>
                      {stateTeacher.pwd &&
                        stateTeacher.confirmPwd &&
                        stateTeacher.pwd !== stateTeacher.confirmPwd && (
                          <>
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <div className="sugesstionFontred d-flex align-items-center gap-1">
                                <FaExclamationCircle /> Passwords do not match
                              </div>
                            </div>
                          </>
                        )}
                    </div>
                  </div>
                  <button
                    className="btn btn-success butonRegister margin_mobiles mt-4 mb-3"
                    onClick={() => {
                      if (stateTeacher.number.length !== selectedCountry?.maxLength) {
                        toast.error(`Please enter ${selectedCountry?.maxLength} digit mobile no`);
                      } else {
                        setregistertype("teacher-registration");
                        setmobilenumber(stateTeacher.number);
                        teacherregisterfunc();
                        setSecondsPassed(0);
                        setTimerActive(true);
                        setisResend(true);
                        setRegisterTeachDis(true);
                      }
                    }}
                    disabled={
                      !(
                        stateTeacher.confirmPwd && pswdregex.test(stateTeacher.pwd) &&
                        stateTeacher.pwd === stateTeacher.confirmPwd &&
                        pincode && stateTeacher.user && userIdregex.test(stateTeacher.user) && stateTeacher.schoolName && stateTeacher.number && stateTeacher.firstName && regexName.test(stateTeacher.firstName)
                      ) || registerTeachDis || (!stateTeacher?.lastName ? false : (stateTeacher?.lastName && stateTeacher?.lastName !== "" && regexName.test(stateTeacher.lastName) ? false : true)) || ((!email && selectedCountry?.dialingCode === "+91") ? false : (!email && selectedCountry?.dialingCode !== "+91") ? true : (email && email !== "" && emailError === "" ? false : true))
                    }
                  >
                    {console.log(selectedSubjectsTeach, "testregtecher")}
                    {lang === "en"
                      ? "Register"
                      : lang === "hi"
                      ? "पंजीकरण"
                      : null}
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      />
      {/* Teacher Modal */}

      {/* admin modal */}
      <ModalComponent
        dialogClassName={"register_modal"}
        show={AdminregisterModal}
        Title={
          lang === "en"
            ? "Admin Registration"
            : lang === "hi"
            ? "शिक्षक पंजीकरण"
            : null
        }
        className={"Register_insidescroll"}
        onClick={() => {
          setAdminregisterModal(false);
          emptyStateTeacher();
        }}
        Content={
          <div>
            <div className="container">
              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "First Name"
                        : lang === "hi"
                        ? "प्रथम नाम"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? "Enter First Name"
                        : lang === "hi"
                        ? "प्रथम नाम दर्ज करें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={stateTeacher.firstName}
                    onChange={(e) => {
                      const userInput = e.target.value;
                      const concatenatedValue =
                        userInput.trim() + stateTeacher.lastName.trim();
                      const finalValue = concatenatedValue.replace(/\s+/g, "");
                      setStateTeacher({
                        ...stateTeacher,
                        firstName: userInput,
                        user: `${finalValue}`,
                        suggestion: false,
                        suggestionCard: false,
                      });
                      setsuccesscheckusernotify("");
                      setcheckusernotify("");
                    }}
                    // isDisabled={TeacherregisterModal ? false : true}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "Last Name"
                        : lang === "hi"
                        ? "उपनाम"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? "Enter Last Name"
                        : lang === "hi"
                        ? "उपनाम दर्ज करें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={stateTeacher.lastName}
                    onChange={(e) => {
                      const userInput = e.target.value;
                      const concatenatedValue =
                        stateTeacher.firstName.trim() + userInput.trim();
                      const finalValue = concatenatedValue.replace(/\s+/g, "");
                      setStateTeacher({
                        ...stateTeacher,
                        lastName: userInput,
                        user: `${finalValue}`,
                        suggestion: false,
                        suggestionCard: false,
                      });
                      setsuccesscheckusernotify("");
                      setcheckusernotify("");
                    }}
                    isDisabled={stateTeacher.firstName ? false : true}
                  />
                </div>
              </div>

              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "Date of Birth"
                        : lang === "hi"
                        ? "जन्मतिथि"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isDate={true}
                    maxDate={moment()
                      .subtract(18, "years")
                      .format("YYYY-MM-DD")}
                    value={stateTeacher.birth}
                    onChange={(e) => {
                      setStateTeacher({
                        ...stateTeacher,
                        birth: e.target.value,
                      });
                    }}
                    isDisabled={stateTeacher.lastName ? false : true}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en" ? "Gender" : lang === "hi" ? "लिंग" : null
                    }
                    Selectplaceholder={
                      lang === "en"
                        ? "Select Gender"
                        : lang === "hi"
                        ? "लिंग चुनें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isDropdown
                    options={options[1]}
                    value={stateTeacher.gender}
                    onChange={(e) => {
                      setStateTeacher({
                        ...stateTeacher,
                        gender: e,
                      });
                    }}
                    isDisabled={stateTeacher.birth ? false : true}
                  />
                </div>
              </div>

              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "Mobile No"
                        : lang === "hi"
                        ? "मोबाइल नं"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? "Enter Mobile No"
                        : lang === "hi"
                        ? "मोबाइल नं दर्ज करें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={stateTeacher.number}
                    onChange={(e) =>
                      handlePhoneNumberChange(e, setStateTeacher)
                    }
                    isDisabled={stateTeacher.gender ? false : true}
                  />
                </div>

                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "Email ID"
                        : lang === "hi"
                        ? "ईमेल आईडी"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? "Enter Email ID"
                        : lang === "hi"
                        ? "ईमेल आईडी दर्ज करें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={email}
                    onChange={handleEmailChange}
                    isDisabled={stateTeacher.number.length !== 10}
                  />
                  {emailError && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "4px",
                      }}
                    >
                      {emailError}
                    </p>
                  )}
                </div>
              </div>

              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "School Name"
                        : lang === "hi"
                        ? "स्कूल के नाम"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? "Enter School Name"
                        : lang === "hi"
                        ? "स्कूल का नाम दर्ज करें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={stateTeacher.schoolName}
                    onChange={(e) => {
                      setStateTeacher({
                        ...stateTeacher,
                        schoolName: e.target.value,
                      });
                    }}
                    isDisabled={emailError || !email}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "Medium of Instruction"
                        : lang === "hi"
                        ? "अनुदेश का माध्यम"
                        : null
                    }
                    Selectplaceholder={
                      lang === "en"
                        ? "Select Medium of Instruction"
                        : lang === "hi"
                        ? "निर्देश का माध्यम चुनें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isDropdown
                    isMulti
                    // options={options[2]}
                    value={stateTeacher.MediumInstruction}
                    // onChange={(e) => {
                    //     setStateTeacher({ ...stateTeacher, MediumInstruction: e, Standard: [] });
                    //     getstandard(e);
                    // }}

                    onChange={handleTeaMediumChange}
                    options={mediumarray}
                    isDisabled={stateTeacher.schoolName ? false : true}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en" ? "Class" : lang === "hi" ? "कक्षा" : null
                    }
                    Selectplaceholder={
                      lang === "en"
                        ? "Select Class"
                        : lang === "hi"
                        ? "कक्षा का चयन करें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isDropdown
                    isMulti
                    value={stateTeacher.Standard}
                    // onChange={(e) => {
                    //     setStateTeacher({ ...stateTeacher, Standard: e });
                    //     getsubjectlist(e, "teacher");
                    // }}
                    onChange={handleTeacherstdChange}
                    options={stdteacherarray}
                    isDisabled={
                      stateTeacher.MediumInstruction.length > 0 ? false : true
                    }
                  />
                </div>
              </div>
              {/* <div className="col-md-6 d-flex flex-row gap-5 w-100">
                                   
                                    <Select
                                        label="Select Subject"
                                        placeholder="Select Subject"
                                        isMulti
                                        value={stateTeacher.Subject}
                                        onChange={handleSubjectChange}
                                        options={subarray}
                                    />
                                      
                                </div> */}
              {stateTeacher.Standard.length > 0 &&
                Object.keys(subteacherarray).length > 0 && (
                  <div className="col-md-6 d-flex flex-row gap-5 w-100">
                    <div className="d-flex flex-column w-100 gap-1">
                      <label className={` Select_label `}>
                        {lang === "en"
                          ? "Subject"
                          : lang === "hi"
                          ? "विषय"
                          : null}
                        <code>*</code>
                      </label>
                      <div className="position-relative d-flex flex-row"></div>

                      <div className="selectallsubjectBack">
                        {Object.keys(subteacherarray).map((className) => (
                          <div key={className}>
                            <div className="pb-1">
                              <div className="Select_label">
                                {" "}
                                Standard - {className}
                              </div>
                            </div>
                            <div className="d-flex flex-row flex-wrap align-items-center row-gap-2 column-gap-4">
                              {subteacherarray[className].map((x, i) => (
                                <div
                                  key={i}
                                  className={`d-flex gap-2 ${
                                    i >= 6 && !showAllSubjectsTeach
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedSubjectsTeach[x._id]}
                                    onChange={() =>
                                      handleCheckboxChangeTeach(x._id)
                                    }
                                  />
                                  <label className="subject_style">
                                    {" "}
                                    {x.variableName}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                        {/* <div className="d-flex justify-content-end border-bottom pb-1">
                                                {Object.values(subteacherarray).flat().length > 6 && (
                                                    <div
                                                        onClick={handleButtonClickTeach}
                                                        className="cursor subject_style pt-2"
                                                    >
                                                        {showAllSubjectsTeach
                                                            ? "View Less ▲"
                                                            : "View More ▼ "}
                                                    </div>
                                                )}
                                            </div> */}

                        <div className="d-flex justify-content-end gap-2 pt-1">
                          <div
                            type="button"
                            className="select_button"
                            onClick={handleSelectAllTeach}
                          >
                            Select All
                          </div>
                          <div
                            type="button"
                            className="clear_button"
                            onClick={handleClearAllTeach}
                          >
                            Clear All
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={
                      lang === "en"
                        ? "Pincode"
                        : lang === "hi"
                        ? "पिनकोड"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? "Enter Pincode"
                        : lang === "hi"
                        ? "पिनकोड दर्ज करें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={pincode}
                    onChange={handlePincodeChange}
                    maxLength={6}
                    type="text"
                    inputMode="numeric"
                    isDisabled={stateTeacher.Standard.length > 0 ? false : true}
                  />
                </div>
                {viewAddressField && (
                  <>
                    <div className="col-md-6">
                      <Input
                        label={"Country Name"}
                        placeholder={"Enter Country Name"}
                        labelClassName={"Select_label"}
                        className={"input-size p-2"}
                        isDisabled={addressDis}
                        value={countryName}
                        onChange={(e) => setCountryName(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label={"State Name"}
                        placeholder={"Enter State Name"}
                        labelClassName={"Select_label"}
                        className={"input-size p-2"}
                        isDisabled={addressDis}
                        value={stateName}
                        onChange={(e) => setStateName(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label={"City Name"}
                        placeholder={"Enter City Name"}
                        labelClassName={"Select_label"}
                        className={"input-size p-2"}
                        isDisabled={addressDis}
                        value={cityName}
                        onChange={(e) => setCityName(e.target.value)}
                      />
                    </div>
                    {areaSingleData ? (
                      <div className="col-md-6">
                        <Input
                          label={"Area Name"}
                          placeholder={"Enter AreaName"}
                          labelClassName={"Select_label"}
                          className={"input-size p-2"}
                          value={areaName}
                          isDisabled={addressDis}
                          onChange={(e) => setAreaName(e.target.value)}
                        />
                      </div>
                    ) : (
                      <div className="col-md-6">
                        <Input
                          label={"Area Name"}
                          placeholder={"Select Area"}
                          labelClassName={"Select_label"}
                          className={"input-size p-2"}
                          value={areaName}
                          isDropdown
                          options={areaData}
                          isDisabled={pincode ? false : true}
                          onChange={(e) => setAreaName(e)}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
              <hr style={{ border: "2px dashed black" }} />

              <div className="col-md-12 d-flex flex-column gap-2 justify-content-center align-items-center modal-dropdown-size">
                <div className="col-md-6 Register_input gap-2 w-100">
                  <div className="d-flex flex-column w-100 relative">
                    {stateTeacher.suggestionCard && (
                      <div className="suggestionAbsolute">
                        {usernamesuggestion.map((name, index) => (
                          <div
                            key={index}
                            className={`d-flex flex-column ${
                              selectedSuggestionteach === name ? "selected" : ""
                            }`}
                            onClick={() => handleSuggestionClickteach(name)}
                          >
                            <div className="textDecvor sugesteGetFont border-bottom py-1 px-2">
                              {/* SAkashpandurangan07 */}
                              {name}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <Input
                      label={
                        lang === "en"
                          ? "User Id"
                          : lang === "hi"
                          ? "प्रयोक्ता आईडी"
                          : null
                      }
                      placeholder={
                        lang === "en"
                          ? "User Id"
                          : lang === "hi"
                          ? "यूजर आईडी सेट करें"
                          : null
                      }
                      labelClassName={"Select_label"}
                      className={"input-size p-2"}
                      value={stateTeacher.user ? `${stateTeacher.user}` : ""}
                      showRightIcon={
                        <div
                          onClick={() => {
                            if (
                              stateTeacher.user &&
                              stateTeacher.lastName &&
                              stateTeacher.firstName &&
                              checksuccessusernotify === ""
                            ) {
                              checkuseridfun();
                            }
                          }}
                          style={{
                            cursor:
                              stateTeacher.user &&
                              stateTeacher.lastName &&
                              stateTeacher.firstName &&
                              checksuccessusernotify === ""
                                ? "pointer"
                                : "default",
                            color: checksuccessusernotify ? "#c1c1c1" : "",
                          }}
                          className="cursor-pointer checkFont"
                        >
                          {lang === "en"
                            ? "Check"
                            : lang === "hi"
                            ? "जाँच करें"
                            : null}
                        </div>
                      }
                      isDisabled={true}
                    />
                    <div className="align-items-center w-100">
                      {checkusernotify && (
                        <div className="sugesstionFontred d-flex align-items-center gap-1">
                          <FaExclamationCircle /> {checkusernotify}
                        </div>
                      )}
                      {checksuccessusernotify && (
                        <div className="sugesstionFontgreen d-flex align-items-center gap-1">
                          <IoIosCheckmarkCircle /> {checksuccessusernotify}
                        </div>
                      )}
                      {stateTeacher.suggestion && (
                        <div
                          className="sugesstionFonblack cursor-pointer"
                          onClick={() => {
                            setStateTeacher({
                              ...stateTeacher,
                              suggestionCard: true,
                            });
                            useridsuggestionlist("teacher");
                          }}
                        >
                          Get Suggestion
                        </div>
                      )}
                    </div>
                  </div>

                  <Input
                    label={
                      lang === "en"
                        ? "Password"
                        : lang === "hi"
                        ? "पासवर्ड"
                        : null
                    }
                    placeholder={
                      lang === "en"
                        ? "Set Password"
                        : lang === "hi"
                        ? "पासवर्ड सेट करें"
                        : null
                    }
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isPassword
                    value={stateTeacher.pwd}
                    onChange={(e) => {
                      setStateTeacher({ ...stateTeacher, pwd: e.target.value });
                    }}
                    isDisabled={areaName ? false : true}
                  />
                  <div className="d-flex flex-column w-100 relative">
                    <div>
                      <Input
                        label={
                          lang === "en"
                            ? "Confirm Password"
                            : lang === "hi"
                            ? "पासवर्ड की पुष्टि कीजिये"
                            : null
                        }
                        placeholder={
                          lang === "en"
                            ? "Set Password"
                            : lang === "hi"
                            ? "सांकेतिक शब्द लगना"
                            : null
                        }
                        labelClassName={"Select_label"}
                        className={"input-size p-2"}
                        isPassword
                        value={stateTeacher.confirmPwd}
                        // onChange={(e) => {
                        //     setStateTeacher({
                        //         ...stateTeacher,
                        //         confirmPwd: e.target.value,
                        //     });
                        // }}
                        onChange={handleConfirmPasswordChangeTec}
                        isDisabled={stateTeacher.pwd ? false : true}
                      />
                    </div>
                    <div>
                      {stateTeacher.pwd &&
                        stateTeacher.confirmPwd &&
                        stateTeacher.pwd !== stateTeacher.confirmPwd && (
                          <>
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <div className="sugesstionFontred d-flex align-items-center gap-1">
                                <FaExclamationCircle /> Passwords do not match
                              </div>
                            </div>
                          </>
                        )}
                    </div>
                  </div>
                  <button
                    className="btn btn-success butonRegister margin_mobiles mt-4 mb-3"
                    onClick={() => {
                      if (stateTeacher.number.length !== 10) {
                        toast.error("Please enter 10 digit mobile no");
                      } else {
                        Adminregisterfunc();
                      }
                    }}
                    disabled={
                      checksuccessusernotify &&
                      stateTeacher.confirmPwd &&
                      Object.keys(selectedSubjectsTeach).length > 0 &&
                      stateTeacher.pwd === stateTeacher.confirmPwd &&
                      areaName
                        ? false
                        : true
                    }
                  >
                    {console.log(selectedSubjectsTeach, "testregtecher")}
                    {lang === "en"
                      ? "Register"
                      : lang === "hi"
                      ? "पंजीकरण"
                      : null}
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      />
      {/* admin modal */}

      {/* Otp Modal for All */}
      <ModalComponent
        dialogClassName={"modalotsize"}
        show={OtpModal}
        Title={"Enter Your OTP"}
        onClick={() => {
          setOtpModal(false);
          setOtp("");
          setRegisterStudDis(false);
          setRegisterTeachDis(false);
        }}
        Content={
          <div>
            <div className="container">
              {selectedCountry?.dialingCode === "+91" ? (
              <div className="otpContent">
                6 Digit OTP has been sent to Your Registered Mobile Number{" "}
                <strong>+91 {mobilenumber}</strong>
              </div>
              ) : (
              <div className="otpContent">
                6 Digit OTP has been sent to Your Registered Email ID{" "}
                <strong>{email}</strong>
              </div>
              )
              }
              <div className="d-flex justify-content-center align-items-center mt-3 mb-4">
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  renderSeparator={<span>&nbsp; &nbsp; &nbsp; &nbsp; </span>}
                  renderInput={(props) => (
                    <input {...props} className="otpInput" />
                  )}
                  inputType="number"
                />
              </div>
              {isResend && (
                <div
                  className="d-flex justify-content-end align-items-end pt-3 pb-2"
                  style={{
                    color: timerActive === false ? "#000" : "",
                    fontWeight: "600",
                    cursor: timerActive === false ? "pointer" : "default",
                  }}
                  onClick={() => {
                    if (timerActive === false) {
                      if (roleName === "Student") {
                        generateOTPfunc("registration", "Stu", "Student");
                      } else if (roleName === "Parent") {
                        generateOTPfunc("registration", "Par", "Parent");
                      } else if (roleName === "Teacher") {
                        generateOTPfunc("registration", "Tec", "Teacher");
                      }
                      setSecondsPassed(0);
                      setTimerActive(true);
                      setisResend(true);
                    }
                  }}
                >
                  {timerActive ? `Resend OTP is : ${countdown}` : "Resend OTP"}
                </div>
              )}
              <div className="d-flex justify-content-center align-items-center">
                <button
                  className="btn btn-success butonRegister w-100"
                  // disabled={
                  //   dataRegStatus ? true : otp.length === 6 ? false : true
                  // }
                  onClick={() => {
                    // successRegister();
                    userotpVerfication("REGISTRATION", registertype);
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        }
      />
      {/* Otp Modal for All */}

      {/* Login Modal */}
      <ModalComponent
        dialogClassName={"loginSize"}
        show={LoginModal}
        Title={`${roleName} Login`}
        onClick={() => {
          setLoginModal(false);
          setroleName("");
          setLoginState({
            user: "",
            pwd: "",
          });
          setUserValidate(false);
          setUserValidateList({});
        }}
        Content={
          <div>
            <div className="container">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <Input
                    label={"User Id / Mobile No"}
                    placeholder={"Enter User Id / Mobile No"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    value={LoginState.user}
                    onChange={(e) => {
                      setselecteduserId("");
                      setUserValidate(false);
                      setUserValidateList({});
                      setLoginState({
                        ...LoginState,
                        user: e.target.value.trim(),
                      });
                      console.log(e.target.value, "yyyyyyyyyyy");
                      console.log(e.target.value.length, "yyyyyyyyyyy");
                      if (isNumber(e.target.value)) {
                        if (e.target.value.length === 10) {
                          uservalidateFunc(e.target.value);
                        }
                      }
                    }}
                  />
                </div>
                {UserValidate &&
                  UserValidateList.otherUser.map((x, i) => (
                    <span
                      className={"Stu_userData gap-1 cursor"}
                      style={{
                        background:
                          selecteduserId === x.userId ? "#004857" : "",
                        color: selecteduserId === x.userId ? "#ffffff" : "",
                      }}
                      onClick={() => {
                        setselecteduserId(x.userId);
                      }}
                    >
                      {x.studentId.slice(1)}
                    </span>
                  ))}

                <div className="col-md-12 mb-3">
                  <Input
                    label={"Password"}
                    placeholder={"Enter Password"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isPassword
                    value={LoginState.pwd}
                    onChange={(e) => {
                      setLoginState({
                        ...LoginState,
                        pwd: e.target.value.trim(),
                      });
                    }}
                  />
                </div>
                <div className="d-flex justify-content-end forgetpwdfont">
                  <span
                    className="cursor"
                    onClick={() => {
                      if (LoginState.user === "") {
                        toast.error("Please enter User Id / Mobile No");
                      } else if (UserValidate && selecteduserId == "") {
                        toast.error("Please select any one user Id");
                      } else {
                        generateResetOTPfunc("reset", "", roleName);
                        setSecondsPassed(0);
                        setTimerActive(true);
                        setisResend(true);
                      }
                    }}
                  >
                    Forgot Password ?
                  </span>
                </div>
                <div className="mb-3">
                  <button
                    className="btn btn-success buttonLogin w-100 mt-3"
                    disabled={!isFormValidLogin()}
                    onClick={() => {
                      if (UserValidate && selecteduserId == "") {
                        toast.error("Please select any one user Id");
                      } else {
                        loginuserfunc();
                      }
                    }}
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      />
      {/* Login Modal */}

      {/* Forget Password Modal */}
      <ModalComponent
        dialogClassName={"modalotsize"}
        show={ForgotpwdModal}
        Title={"Forgot Password"}
        onClick={() => {
          setForgotpwdModal(false);
          setroleName("");
          setLoginState({
            user: "",
            pwd: "",
          });
          setUserValidate(false);
          setUserValidateList({});
          setOtpPwd("")
        }}
        Content={
          <div>
            <div className="container">
              { MobCorrect.test(loginmobilenumber) ? (
              <div className="otpContent">
                6 Digit OTP has been sent to Your Registered Mobile Number{" "}
                <strong>+91 {loginmobilenumber}</strong>
                {/* <span className="changecontent cursor">Change</span> */}
              </div>
              ) : (
              <div className="otpContent">
                6 Digit OTP has been sent to Your Registered Email ID{" "}
                <strong>{loginmobilenumber}</strong>
                {/* <span className="changecontent cursor">Change</span> */}
              </div>  
              )
              }
              <div className="d-flex justify-content-center align-items-center mt-3 mb-4">
                <OtpInput
                  value={otpPwd}
                  onChange={setOtpPwd}
                  numInputs={6}
                  renderSeparator={<span>&nbsp; &nbsp; &nbsp; &nbsp; </span>}
                  renderInput={(props) => (
                    <input {...props} className="otpInput" />
                  )}
                  inputType="number"
                />
              </div>
              {isResend && (
                <div
                  className="d-flex justify-content-end align-items-end pt-3 pb-2"
                  style={{
                    color: timerActive === false ? "#000" : "",
                    fontWeight: "600",
                    cursor: timerActive === false ? "pointer" : "default",
                  }}
                  onClick={() => {
                    if (timerActive === false) {
                      // generateResetOTPfunc("reset", "", roleName);
                      // setTimerActive(true)

                      generateResetOTPfunc("reset", "", roleName);
                      setSecondsPassed(0);
                      setTimerActive(true);
                      setisResend(true);
                    }
                  }}
                >
                  {timerActive ? `Resend OTP is : ${countdown}` : "Resend OTP"}
                </div>
              )}
              <div className="d-flex justify-content-center align-items-center pb-3">
                <button
                  className="btn btn-success butonRegister w-100"
                  //   disabled={!setOtpPwd}
                  disabled={otpPwd.length === 6 ? false : true}
                  onClick={() => {
                    forgototpVerfication();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        }
      />
      {/* Forget Password Modal */}

      {/* Enter New Password Modal */}
      <ModalComponent
        dialogClassName={"modalotsize"}
        show={pwdModal}
        Title={"Enter Your New Password"}
        onClick={() => {
          setPwdModal(false);
          setroleName("");
          setLoginState({
            user: "",
            pwd: "",
          });
          setUserValidate(false);
          setUserValidateList({});
          setOtpPwd("")
        }}
        Content={
          <div>
            <div className="container">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <Input
                    label={"Password"}
                    placeholder={"Enter Password"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isPassword
                    value={enterPwd.pwd}
                    onChange={(e) => {
                      setEnterPwd({ ...enterPwd, pwd: e.target.value });
                    }}
                  />
                  <div>
                    {enterPwd.pwd && !pswdregex.test(enterPwd.pwd) && (
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <div className="sugesstionFontred d-flex align-items-center gap-1">
                            <FaExclamationCircle />
                            Password must have 1 capital letter, 1 number, 1
                            symbol & min 6 chars
                          </div>
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-md-12 mb-1">
                  <Input
                    label={"Confirm Password"}
                    placeholder={"Enter Confirm Password"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isPassword
                    value={enterPwd.confirmPwd}
                    onChange={(e) => {
                      setEnterPwd({ ...enterPwd, confirmPwd: e.target.value });
                    }}
                    isDisabled={enterPwd.pwd && pswdregex.test(enterPwd.pwd) ? false : true}
                  />
                </div>
                {enterPwd.confirmPwd &&
                  enterPwd.pwd !== enterPwd.confirmPwd && (
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div className="sugesstionFontred d-flex align-items-center gap-1">
                        <FaExclamationCircle /> password mismatch
                      </div>
                    </div>
                  )}
                <div className="mb-3">
                  <button
                    className="btn btn-success buttonLogin w-100 mt-3"
                    disabled={
                      enterPwd.pwd && pswdregex.test(enterPwd.pwd) && enterPwd.pwd === enterPwd.confirmPwd
                        ? false
                        : true
                    }
                    onClick={() => {
                      pwdResetfunc();
                    }}
                    // onClick={pwdResetfunc}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      />
      {/* Enter New Password Modal */}

      <ModalComponent
        show={routeModal}
        dialogClassName={"ModalSizeMobile"}
        Title={"Routes 2 Roots"}
        onClick={() => {
          setRouteModal(false);
        }}
        Content={
          <div className="d-flex justify-content-center align-items-center height_30">
            <span className="h3">Coming Soon...</span>
          </div>
        }
      />

      <ModalComponent
        show={ncertModal}
        isNcert={true}
        dialogClassName={"ModalSizeMobile"}
        onClick={() => {
          setNcertModal(false);
        }}
      />

      {/* Student Add Book Modal */}
      <ModalComponent
        // size={"xl"}
        dialogClassName={"register_modal"}
        show={StudentAddbookModal}
        // Title={`Add ${UserProfileData?.standard[0]?.variableName} Standard Katbook's`}
        Title={`Add Katbook`}
        onClick={() => {
          setStudentAddbookModal(false);
          setaddbookOpen(false);
          setActiveIcon(null);
        }}
        className={"Register_insidescroll"}
        Content={
          <div>
            <div className="container">
              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={"Medium of Instruction"}
                    Selectplaceholder={"Select Medium of Instruction"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    // options={options[2]}
                    isDropdown
                    isMulti
                    value={state.MediumInstruction}
                    // onChange={(e) => {
                    //     setState({ ...state, MediumInstruction: e });
                    //     getstandard(e);
                    // }}
                    onChange={handleaddbookMediumChange}
                    options={mediumarray}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label={"Class"}
                    Selectplaceholder={"Select Standard"}
                    labelClassName={"Select_label"}
                    className={"input-size phandleaddbookMediumChange-2"}
                    isDropdown
                    isMulti
                    value={state.Standard}
                    onChange={(e) => {
                      setState({ ...state, Standard: e });
                      setsubarray([]);
                      setSelectedSubjects([]);
                      getsubjectlist(e);
                    }}
                    options={stdarray}
                    isDisabled={
                      state.MediumInstruction.length > 0 ? false : true
                    }
                  />
                </div>
              </div>

              {state.Standard.length > 0 &&
                Object.keys(subarray).length > 0 && (
                  <div className="col-md-6 d-flex flex-row gap-5 w-100">
                    <div className="d-flex flex-column w-100 gap-1">
                      <label className={` Select_label `}>
                        Subject<code>*</code>
                      </label>
                      <div className="position-relative d-flex flex-row"></div>
                      <div className="selectallsubjectBack">
                        {Object.keys(subarray).map((className) => (
                          <div key={className}>
                            <div className="pb-1">
                              <div className="Select_label">
                                {" "}
                                Standard - {className}
                              </div>
                            </div>
                            <div className="d-flex flex-row flex-wrap align-items-center row-gap-2 column-gap-4">
                              {Array.isArray(subarray[className]) &&
                                subarray[className].map((x, i) => (
                                  <div
                                    key={i}
                                    className={`d-flex gap-2 ${
                                      i >= 6 && !showAllSubjectsTeach
                                        ? "d-none"
                                        : ""
                                    }`}
                                  >
                                    <input
                                      type="checkbox"
                                      disabled={selectedSubjects[x._id]}
                                      checked={
                                        String(selectedSubjectsTeach[x._id]) ===
                                        "true"
                                          ? true
                                          : false
                                      }
                                      onChange={() =>
                                        handleCheckboxChangeTeach(x._id)
                                      }
                                    />
                                    <label className="subject_style">
                                      {" "}
                                      {x.variableName}
                                    </label>
                                  </div>
                                ))}
                            </div>
                          </div>
                        ))}
                        {console.log(subarray, "DDDDDDDDDD")}
                        <div className="d-flex justify-content-end border-bottom pb-1">
                          {Object.values(subarray).flat().length > 6 && (
                            <div
                              onClick={handleButtonClick}
                              className="cursor subject_style pt-2"
                            >
                              {showAllSubjects ? "View Less ▲" : "View More ▼ "}
                            </div>
                          )}
                        </div>

                        <div className="d-flex justify-content-end gap-2 pt-1">
                          <div
                            type="button"
                            className="select_button"
                            onClick={handleSelectAllTeach}
                          >
                            Select All
                          </div>
                          <div
                            type="button"
                            className="clear_button"
                            onClick={handleClearAllTeach}
                          >
                            Clear All
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              <div className="col-md-12 d-flex flex-column gap-2 justify-content-center align-items-center modal-dropdown-size">
                <div className="col-md-6 Register_input gap-2 w-100 justify-content-between">
                  <p className={"note_txtbook"}>
                    Note: As a student, they are allowed to select a maximum of
                    6 subjects.
                  </p>
                  <button
                    className="btn btn-success butonRegister mt-4 mb-3"
                    onClick={() => {
                      updateBooks("student");
                      bookFetchGo();
                    }}
                    disabled={
                      state.Standard.length > 0 &&
                      Object.keys(selectedSubjectsTeach).length > 0
                        ? false
                        : true
                    }
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      />
      {/* Student Registration Modal */}

      {/* Teacher Add book Modal */}
      <ModalComponent
        dialogClassName={"register_modal"}
        show={TeacherAddbookModal}
        Title={"Add Katbook"}
        className={"Register_insidescroll"}
        onClick={() => {
          setTeacherAddbookModal(false);
          setaddbookOpen(false);
          setActiveIcon(null);
        }}
        Content={
          <div>
            <div className="container">
              <div className="row pt-2 input_gap">
                <div className="col-md-6">
                  <Input
                    label={"Medium of Instruction"}
                    Selectplaceholder={"Select Medium of Instruction"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isDropdown
                    isMulti
                    // options={options[2]}
                    value={stateTeacher.MediumInstruction}
                    // onChange={(e) => {
                    //     setStateTeacher({ ...stateTeacher, MediumInstruction: e, Standard: [] });
                    //     getstandard(e);
                    // }}
                    onChange={handleTeaMediumChange}
                    options={mediumarray}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label={"Class"}
                    Selectplaceholder={"Select Standard"}
                    labelClassName={"Select_label"}
                    className={"input-size p-2"}
                    isDropdown
                    isMulti
                    value={stateTeacher.Standard}
                    // onChange={(e) => {
                    //     setStateTeacher({ ...stateTeacher, Standard: e });
                    //     getsubjectlist(e, "teacher");
                    // }}
                    onChange={handleTeacherstdChangeForAddBook}
                    options={stdteacherarray}
                    isDisabled={
                      stateTeacher.MediumInstruction.length > 0 ? false : true
                    }
                  />
                </div>
              </div>
              {console.log(stateTeacher.MediumInstruction, "MediumInstruction")}

              {stateTeacher.Standard.length > 0 &&
                Object.keys(subteacherarray).length > 0 && (
                  <div className="col-md-6 d-flex flex-row gap-5 w-100">
                    <div className="d-flex flex-column w-100 gap-1">
                      <label className={` Select_label `}>
                        Subject<code>*</code>
                      </label>
                      <div className="position-relative d-flex flex-row"></div>

                      <div className="selectallsubjectBack">
                        {Object.keys(subteacherarray).map((className) => (
                          <div key={className}>
                            <div className="pb-1">
                              <div className="Select_label">
                                {" "}
                                Standard - {className}
                              </div>
                            </div>
                            <div className="d-flex flex-row flex-wrap align-items-center row-gap-2 column-gap-4">
                              {subteacherarray[className].map((x, i) => (
                                <div
                                  key={i}
                                  className={`d-flex gap-2 ${
                                    i >= 6 && !showAllSubjectsTeach
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <input
                                    type="checkbox"
                                    disabled={selectedSubjects[x._id]}
                                    checked={
                                      String(selectedSubjectsTeach[x._id]) ===
                                      "true"
                                        ? true
                                        : false
                                    }
                                    onChange={() =>
                                      handleCheckboxChangeTeach(x._id)
                                    }
                                  />
                                  <label className="subject_style">
                                    {" "}
                                    {x.variableName}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                        {/* { console.log(selectedSubjects,"DDDDDDDDDD") } */}
                        {console.log(selectedSubjectsTeach, "DDDDDDDDDD")}
                        <div className="d-flex justify-content-end border-bottom pb-1">
                          {Object.values(subteacherarray).flat().length > 6 && (
                            <div
                              onClick={handleButtonClickTeach}
                              className="cursor subject_style pt-2"
                            >
                              {showAllSubjectsTeach
                                ? "View Less ▲"
                                : "View More ▼ "}
                            </div>
                          )}
                        </div>

                        <div className="d-flex justify-content-end gap-2 pt-1">
                          <div
                            type="button"
                            className="select_button"
                            onClick={handleSelectAllTeach}
                          >
                            Select All
                          </div>
                          <div
                            type="button"
                            className="clear_button"
                            onClick={handleClearAllTeach}
                          >
                            Clear All
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              <hr style={{ border: "2px dashed black" }} />

              <div className="col-md-12 d-flex flex-column gap-2 justify-content-center align-items-center modal-dropdown-size">
                <div className="col-md-6 Register_input gap-2 w-100 justify-content-between">
                  {/* {UserProfileType?.usertype === "Student" ? (
                    <p className={"note_txtbook"}>
                      Note: As a student, they are allowed to select a maximum
                      of 6 subjects.
                    </p>
                  ) : UserProfileType?.usertype === "Admin" ? null : (
                    <p className={"note_txtbook"}>
                      Note: As a teacher, they are allowed to select a maximum
                      of 4 standards and a maximum of 8 subjects.
                    </p>
                  )} */}
                  <button
                    className="btn btn-success butonRegister margin_mobiles mt-4 mb-3"
                    onClick={() => {
                      UserProfileType?.usertype === "Student"
                        ? updateBooks("student")
                        : updateBooks("teacher");
                      bookFetchGo();
                    }}
                    disabled={
                      stateTeacher.Standard.length > 0 &&
                      Object.keys(selectedSubjectsTeach).length > 0
                        ? false
                        : true
                    }
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      />
      {/* Teacher Add book Modal */}


        <ModalComponent
        show={logOutUserModal}
        onClick={() => setLogOutUserModal(false)}
        Title=""
        Content={logOutContent}
        dialogClassName={"registerPopup"}
        // size="md"
        isGradient={false}
      />
    </Fragment>
  );
};

// Default props for activeTab and handleTabClick
Header.defaultProps = {
  activeTab: "Home", // Default active tab is set to 'Home'
  handleTabClick: () => {}, // Default click handler is an empty function
};

export default Header;

